// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-06T21:26:53.310Z
// Property: Emilia at Fair Oaks (ID: 6767906449167661)
// Collections: 51 amenities, 7 floorplans (live), 19 photos, 67 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 7 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162466",
  "multihub_property_id": "6767906449167661",
  "property_external_id": "2272271",
  "property_zillow_url": "https://www.zillow.com/apartments/boerne-tx/emilia/CdB4W9/",
  "property_apartments_url": "https://www.apartments.com/emilia-boerne-tx/zqdn1mw/",
  "property_google_business_url": "https://www.google.com/maps/place/Emilia+at+Fair+Oaks+Apartments/@29.681283,-98.637882,994m/data=!3m2!1e3!4b1!4m6!3m5!1s0x865c6544bd3a18b5:0x47fdd79fb7a938be!8m2!3d29.681283!4d-98.637882!16s%2Fg%2F11zkpd20wn?entry=ttu&g_ep=EgoyMDI2MDgxNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57322531477",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "2272271\np2239491",
  "property_status": null,
  "property_slug": "emilia",
  "property_name": "Emilia at Fair Oaks",
  "property_website_url": "https://www.emiliafairoaks.com/",
  "property_domain": "https://www.emiliafairoaks.com/",
  "property_address": "7868 Lost Creek Gap",
  "property_full_address": "7868 Lost Creek Gap, Boerne, TX 78015",
  "property_address_1": "7868 Lost Creek Gap",
  "property_address_2": null,
  "property_address_city": "Boerne",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "78015",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Van Raub",
  "property_address_latitude": "29.681702",
  "property_address_longitude": "-98.6383133",
  "property_email": "emiliamanager@mox.living",
  "property_phone": "(855) 779-4069",
  "property_call_tracking_phone": "855-779-4069",
  "property_company_name": "Mox",
  "property_company_url": "https://www.mox.living/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "<p><strong>Emilia Fair Oaks Apartments offers </strong>brand-new studio, one- and two-bedroom homes in the Leon Springs corridor, where the Hill Country softens into northwest San Antonio. Just off IH-10 at Camp Bullis Road — mere minutes from The Dominion and La Cantera, and a world away from the morning rush.</p>",
  "property_long_description": "<p><strong>The Sweet Spot Between Ralph Fair Road and The Dominion</strong></p><p>In northwest San Antonio, the limestone hills roll in and the traffic thins out while the city stays close enough to reach on a whim. <strong>Emilia Fair Oaks</strong> sits right there, in the Leon Springs corridor just off IH-10 at Camp Bullis Road, on the quiet side of Loop 1604. The location comes with a rare advantage. Your morning drive moves against the inbound rush instead of into it, so while the rest of the city inches toward downtown, you're already gone. Everything you need stays close by. Camp Bullis is five miles down the road. UTSA and La Cantera are eight. Valero is nine, USAA thirteen, and the South Texas Medical Center fifteen. The Leon Springs H-E-B waits two miles down the access road, and downtown Boerne's Hill Country Mile is a pretty eleven-mile drive northwest, saved for slow Saturdays. Families settle into Northside ISD at Leon Springs Elementary, Rawlinson Middle, and Clark High.</p><p><br></p><p>Inside, tall ceilings and generous windows keep the rooms bright. Open-concept studio, one, and two-bedroom floor plans wear hardwood-style flooring, brand-new appliance packages, and roomy closets, with private patios and balconies that open onto Hill Country views in select homes. Beyond your door there's plenty of room to spread out. A resort-style pool and sundeck. A 24-hour fitness center. A clubhouse made for lingering, a courtyard with grilling stations, and a dog park for the four-legged residents. EV charging, covered parking, package receiving, valet trash, and around-the-clock maintenance.</p><p><br></p><p>All the beauty Fair Oaks Ranch and The Dominion are known for, with a lease instead of a mortgage. Come see it for yourself.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-39f0-7705-8d35-f08ed8da85ee.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with apartment buildings in the background.",
    "public_id": "019ffd19-39f0-7705-8d35-f08ed8da85ee",
    "storage_key": "property/6767906449167661/019ffd19-39f0-7705-8d35-f08ed8da85ee.webp",
    "width": 1998,
    "height": 1333
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "125",
  "property_year_built": "2026",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "55.2",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $150-300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "0",
  "property_max_pets": "0",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We are proud partners with PetScreening.com! Pet rents range; please contact the office for details on rents and size/breed restrictions.",
  "property_pet_policy_description": "We understand that pets are part of the family. That's why your pets are welcome to join our community.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://emiliafairoaks.securecafeapplicant.com/onlineleasing/content3/access/the-emilia/floorplans",
  "property_resident_portal_url": "https://emiliafairoaks.securecafenet.com/residentservices/the-emilia/userlogin",
  "property_apply_now_url": "https://emiliafairoaks.securecafeapplicant.com/onlineleasing/content3/access/the-emilia/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-3664-73f4-a08c-0874082f8443.webp",
  "property_primary_logo_media": {
    "alt_text": "Emila logo",
    "public_id": "019ffd19-3664-73f4-a08c-0874082f8443",
    "storage_key": "property/6767906449167661/019ffd19-3664-73f4-a08c-0874082f8443.webp",
    "width": 1261,
    "height": 608
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a01058-b531-7422-a020-454ebb222d16.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a01058-b531-7422-a020-454ebb222d16",
    "storage_key": "property/6767906449167661/01a01058-b531-7422-a020-454ebb222d16.webp",
    "width": 1261,
    "height": 608
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a01058-aa99-75eb-ae2b-1eac46bdaaae.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a01058-aa99-75eb-ae2b-1eac46bdaaae",
    "storage_key": "property/6767906449167661/01a01058-aa99-75eb-ae2b-1eac46bdaaae.webp",
    "width": 1261,
    "height": 608
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b110-11a0-73bb-ba59-e09d0fa98a78.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b10f-c4d1-77d8-b6d1-8c4ee1490c37.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#141414",
  "property_secondary_color": "#bc7434",
  "property_font_color": null,
  "property_color_4": "#c5cab5",
  "property_color_3": "#3a3b40",
  "property_color_5": "#586168",
  "property_color_6": "#896656",
  "property_color_7": "#ecebe7",
  "property_color_8": "#d2d2d3",
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "483 - 1112",
  "property_sqft_min": "483",
  "property_sqft_max": "1112",
  "property_price_range": "999 - 1729",
  "property_price_min": "999",
  "property_price_max": "1729",
  "property_available_units": 56,
  "property_facebook_url": "https://www.facebook.com/liveatemilia/",
  "property_instagram_url": "https://www.instagram.com/live_atemilia/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJtRg6vURlXIYRvjipt5_X_Uc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/emilia-at-fair-oaks-apartments-boerne-4",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Emilia",
  "property_home_romance_title": "Embrace Your Ideal Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, polished up.</strong> At Emilia, a fitness center, pool with sundeck, and clubhouse make downtime feel effortless, while EV charging, covered parking options, package receiving, online rent payment, and 24-hour maintenance keep the details moving.</p><p>Inside, hardwood-style flooring, high ceilings, large closets, efficient appliances, and washer/dryer connections bring a clean, contemporary finish to studio, one-, and two-bedroom apartments in Boerne.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a floor plan that works as hard as your day does.</strong> Emilia offers studio, one-bedroom, and two-bedroom apartments in Boerne with open-concept options, select two-bath layouts, and everyday upgrades like stainless steel appliances, granite countertops, high ceilings, large closets, and in-unit washer and dryer connections.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Emilia in crisp Hill Country detail.</strong> Browse bright interiors with white cabinetry, dark granite countertops, stainless steel appliances, wide windows, soft-carpeted bedrooms, and ceiling fans. Then take in the pool courtyard, contemporary clubhouse lounge, fitness center, and scenic Boerne surroundings. From studio to two-bedroom layouts, the gallery offers a quick look at the finishes, flow, and everyday spaces waiting to be explored in person.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Closer to San Antonio than Boerne</strong>, you'll find Hill Country calm meets city access at Emilia. From the Leon Springs corridor, IH-10 and Camp Bullis Road put Fair Oaks Ranch, The Rim, and The Shops at La Cantera minutes away, all reached against the inbound traffic rather than with it. A short drive northwest, downtown Boerne brings the Hill Country Mile, local coffee, breweries, and restaurants, plus Cibolo Trail for outdoor days.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews highlight an easy, welcoming start at Emilia.</strong> Residents praise the leasing team’s professionalism, quick responses, and patient guidance through tours, questions, and move-in. Beth and Martha are often mentioned for making the process feel simple and stress-free, while Mr. Rick adds a friendly presence around the grounds.</p><p>Clean, well-kept apartments, an elegant setting, and attentive service all come through in resident feedback—giving Emilia a strong first impression worth exploring further.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your map between Hill Country calm and city convenience.</strong> From Emilia in Van Raub, you’re close to the everyday routes that make Boerne living easy—Ralph Fair Road and I-10 for trips toward Fair Oaks Ranch, Leon Springs, The Rim, and The Shops at La Cantera. When the day calls for local flavor, head into downtown Boerne for the Hill Country Mile’s storefronts, coffee, breweries, and restaurants like The Dienger Trading Co. and Cibolo Creek Brewing Co. Outdoor time is just as easy to plan, with the Cibolo Trail tracing the creek through town and The Cibolo offering nature-center scenery. Use the map to find your go-to stops, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Emilia connects you to the area.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>More ease between every errand, workout, and wind-down.</strong> Emilia’s amenity mix is built around useful comfort: start the day in the fitness center, cool off at the pool and sundeck, or settle into the clubhouse when you want a change of scenery. EV charging, covered parking options, package receiving, online rent payment, and 24-hour maintenance help keep the practical parts of life moving smoothly.</p><p>Inside your apartment, contemporary finishes add a polished feel without overcomplicating the routine—think hardwood-style flooring, high ceilings, large closets, efficient appliances, and washer/dryer connections. Browse the <a href=\"/gallery\">amenity photos</a>, compare <a href=\"/floor-plans\">studio, one-, and two-bedroom layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Emilia in Boerne firsthand.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Emilia.</strong> Brand-new studio, one-, and two-bedroom apartments pair polished Hill Country living with simple everyday conveniences and connected Boerne access. Explore the <a href=\"/floor-plans\">available floor plans</a>, choose the layout that fits your needs, and apply online when you’re ready to make Emilia home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Emilia leasing team for help with brand-new studio, one-bedroom, and two-bedroom apartments, everyday conveniences, and access to I-10 and Ralph Fair Road. We’re here to help you find your place in Boerne’s Hill Country setting.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Emilia?</strong> Start here for quick answers about brand-new Hill Country living, available <a href=\"/floor-plans\">studio, one-, and two-bedroom apartments</a>, everyday conveniences, and what to expect when leasing and living here. If you need more details, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits your day.</strong> Emilia’s studio, one-bedroom, and two-bedroom apartments in Boerne give you a clear range of choices, from streamlined open-concept layouts to roomier homes with separate bedrooms and two-bath options. Compare floor plan cards by layout, pricing, and availability, then look for the details that make daily routines easier: modern kitchens with stainless steel appliances and granite countertops, high ceilings, large closets, cable and high-speed internet readiness, and in-unit washer and dryer connections.</p><p>Whether you want a compact home base or extra room to spread out, each layout is designed with a fresh, contemporary feel. Browse current availability, view apartment photos in the <a href=\"/gallery\">gallery</a>, and <a href=\"/schedule-a-tour\">schedule a tour</a> when you are ready to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Scroll through Emilia one detail at a time.</strong> The gallery brings the community into focus: sunlit apartment interiors with crisp white cabinetry, dark granite counters, stainless steel appliances, and wide windows; bedrooms with soft carpeting and ceiling fans; and outdoor moments framed by Hill Country views.</p><p>Pause on the pool courtyard, the clubhouse lounge with contemporary seating, and the fitness center with room to stretch or move through a routine. From compact studios to more spacious two-bedroom layouts, each photo helps you connect finishes, flow, and everyday conveniences before you tour. Explore the <a href=\"/amenities\">amenity spaces</a>, compare <a href=\"/floor-plans\">available layouts</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Emilia in Boerne in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Emilia from every angle.</strong> Use the interactive map to browse available apartments, see how the community connects to I-10 and Ralph Fair Road, and get a feel for nearby Boerne dining, shopping, and Hill Country destinations.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash, the treats, and the sunny-window routine.</strong> At Emilia, cats and dogs can settle into a Boerne apartment community with practical comforts built around everyday pet care. The on-site dog park gives dogs a convenient place to burn off energy close to home, while courtyards, picnic areas, and outdoor grilling spaces make quick fresh-air breaks feel easy.</p><p>Inside, features like hardwood-style floors, large closets, natural lighting, and efficient appliances help keep your routine simple after walks, feedings, and cleanups. When you are comparing homes, explore the <a href=\"/floor-plans\">available floor plans</a> and check out the <a href=\"/amenities\">pet-friendly amenities</a> that make life with your four-legged companion feel right at home.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Emilia?</strong> Share brand-new Hill Country living, polished apartment spaces, and a connected Boerne address with a friend. Invite them to explore Emilia and find their place here, too.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong> Log in to pay rent, submit maintenance requests, and manage your Emilia account in one convenient place—so everyday living stays as polished and connected as your Boerne apartment.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback points to a smooth, welcoming experience at Emilia.</strong> Reviewers consistently praise the team’s professionalism, responsiveness, and patience—from tours and lease questions to move-in day. Beth and Martha are called out by name for making the process “simple and stress-free,” while Mr. Rick is noted as a pleasant presence around the grounds.</p><p>You’ll also see residents highlight clean, well-maintained apartments, an elegant property setting, and a comfortable community feel. Whether you’re reading first impressions or early move-in experiences, the theme is clear: attentive service helps Emilia feel easy from the start. Have questions of your own? Connect with the <a href=\"/contact-us\">leasing team</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_created_at": "1786657663018",
  "property_scheduletour_blurb": "<p><strong>See Emilia up close.</strong> Tour brand-new studio, one-bedroom, and two-bedroom apartments with polished interiors, everyday conveniences, and inviting spaces to recharge. From the resort-style pool to easy I-10 access, the details come together better in person. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The Emilia leasing team will follow up soon. In the meantime, picture brand-new Hill Country living with polished studio, one-, and two-bedroom apartments, connected Boerne access, and inviting spaces to recharge.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Emilia before you arrive.</strong> Start with the community virtual tour, then move at your own pace through the exterior, leasing area, clubhouse, lounge, fitness center, and swimming pool. Each view helps you picture the flow of the property—where you’ll enter, unwind, work out, cool off, and connect the shared spaces you’ve seen in the <a href=\"/gallery\">photo gallery</a>.</p><p>Step inside the available one-bedroom, one-bath apartment tour to see the open living layout, modern kitchen finishes, natural light, bedroom space, and everyday details from every angle. When you’re ready for the next look, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Emilia in Boerne in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Emilia",
  "property_seo_title_home": "Emilia |  Apartments in Boerne, TX",
  "property_seo_description_home": "Discover Emilia in Boerne, TX! Stylish studios and spacious 2-bedroom apartments with a pool, fitness center, and modern amenities await.",
  "property_seo_title_floorplans": "Floor Plans | Boerne, TX Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal space at Emilia in Boerne, TX! Choose from studio, one-bedroom, or two-bedroom floor plans tailored for comfort and style. Browse now!",
  "property_seo_title_amenities": "Amenities | Boerne, TX Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Emilia in Boerne, TX! Enjoy a stunning pool, state-of-the-art fitness center, and more. Your dream home with top-notch amenities awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Boerne, TX",
  "property_seo_description_gallery": "Step into Emilia, Boerne's vibrant community. Enjoy stunning studios to two-bedroom homes, a pool, fitness center, and more. Picture your new life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Emilia Apartments",
  "property_seo_description_virtualtours": "Step into Emilia in Boerne, TX! Take a virtual tour of our stylish studios, one and two-bedroom apartments. Your next home awaits—come experience it today!",
  "property_seo_title_interactivemap": "Interactive Map | Emilia Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Emilia in Boerne, TX! Use our interactive map to explore studio, one, and two-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Boerne, TX",
  "property_seo_description_neighborhood": "Uncover Boerne's charm at Emilia. Dive into local favorites, vibrant shops, and serene parks just steps from your studio, one, or two-bedroom apartment.",
  "property_seo_title_contact": "Contact Us | Emilia",
  "property_seo_description_contact": "Reach out to the Emilia team in Boerne, TX! Whether you need info on our studios, one-beds, or two-beds, we’re here to help. Let’s connect today!",
  "property_seo_title_faqs": "FAQs | Apartments in Boerne, TX",
  "property_seo_description_faqs": "Unlock answers about Emilia in Boerne, TX! From floor plans to amenities like a pool, fitness center, and more—browse our FAQs for all you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Boerne, TX",
  "property_seo_description_reviews": "Dive into life at Emilia in Boerne, TX! From studios to two-bedroom apartments, enjoy top-tier amenities and hear why our residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Boerne, TX",
  "property_seo_description_applynow": "Find your ideal home at Emilia in Boerne, TX! Enjoy a pool, fitness center, and modern amenities. Apply online today for a vibrant lifestyle that awaits!",
  "property_seo_title_residentaccess": "Resident Access | Emilia",
  "property_seo_description_residentaccess": "Log in to Emilia's resident portal in Boerne, TX, to effortlessly manage rent payments, maintenance requests, and all your community needs—your home, your way!",
  "property_seo_title_referafriend": "Refer A Friend | Emilia",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Emilia in Boerne, TX, and enjoy exclusive rewards while building a vibrant community together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Emilia",
  "property_seo_description_scheduletour": "Experience Emilia in Boerne, TX—where modern living meets charming community vibes. Schedule a tour today and unlock your perfect home!",
  "property_seo_title_privacy": "Privacy Policy | Emilia",
  "property_seo_description_privacy": "At Emilia in Boerne, TX, your privacy matters. Understand how we protect your information while you enjoy modern living. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Emilia",
  "property_seo_description_accessibility": "At Emilia in Boerne, TX, we prioritize accessibility and inclusivity. Join our community where everyone deserves a comfortable place to call home.",
  "property_seo_title_sitemap": "Sitemap | Emilia",
  "property_seo_description_sitemap": "Unlock the best of Boerne living at Emilia! Navigate our website sitemap to plan your next adventure in luxurious apartments tailored for your lifestyle.",
  "property_seo_title_thankyou": "Thank You | Emilia",
  "property_seo_description_thankyou": "Thank you for reaching out to Emilia in Boerne, TX! Our team will connect with you soon to help find your perfect apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Boerne, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791321899771",
  "amenities": [
    {
      "id": "ec_e9d15fc5e6a83153ec777be7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128171928",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c085203c3868920041b7c07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995608",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ecee6970f4a498eb3fbda99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995602",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41b70b72dd3e9fb2a82e49c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995601",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_827f3c73b0eb0a155cf38baf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995599",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cb315ea2b0c7366dd995352",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127060813",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3419898a304b255dac584119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846721",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9eec994d166a40b9fe4a6d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846717",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_541d811afb2f3ccd470108d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846718",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae3af141b4a9da10b667e185",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846714",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00b2796454184527af710241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846712",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3502e099d7293b9eff2d193e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846711",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef217e4fb4010ba1ce8abe89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846710",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82bb8da7f362da5c9d4aa4b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846709",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5faa360895f5df660241f9cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846708",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cc56c73099b741e12e9b765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846703",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c40f41f0679910708656324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126293296",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5dceb133ff0fbd70fa57c2d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126316003",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb625fc1ed70030e9358be1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846706",
      "title": "Parking Lot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9e8bad1b927ae877fbf9030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127065202",
      "title": "EV Chargers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69075b6b0b3b7f80cec1c322",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127065211",
      "title": "Natural Lighting",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d4d98bad514a01c133cde2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189119",
      "title": "24-hour maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_916fa8dce97b90da51c90b4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189120",
      "title": "Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d620eccc2c79a129a1b46ee0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189124",
      "title": "Online maintenance portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc7a079233dfd4020fef2cad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189125",
      "title": "Valet trash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a3eac01643881fe7acd75ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189127",
      "title": "Online rent payment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01a5bc78c017c34b7d0819e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189087",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50c4b1a8c5f9fb0d8e7f284e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995610",
      "title": "Hardwood-Style Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c960528747e109d263d6ca15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995609",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5126c1470fdcd248bb6ccb65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995604",
      "title": "Hill Country Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_968264bcc4aa943d03af79a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "127995603",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82c46ccaf36ff0b37a2e9998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846748",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd9beaa43a331d26bf2b2502",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846745",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eefdf7b842f64543b4ea97f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846742",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b2624d4f489bd15632d7445",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846741",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a201dcc6718efc3c8480195d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846739",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9382687069635eb6afba0be8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846738",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d41524723a0094615f909b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846737",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c6045d4842a44d04f6b2a50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846736",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fb7e772191c363a7e2fe804",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846735",
      "title": "Handrails",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_875421c0606203519e579793",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846733",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1381676baa035fbbfa77f4f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846732",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c62d84541fa0e82e13e4901",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846730",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c68c98ce264d604d56c95006",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846728",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d572ff5736c5d28f727a0f27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846727",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83e0c0f5eb36e945381155af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846725",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01fecec14c6d3582e3d72fec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846750",
      "title": "Icemaker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd33df698ed1f6d9c17776af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "126846758",
      "title": "Electricity",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bacb1d44f8431cbf36d5b143",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189091",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e08cec07da0bc3c6e4e9984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189093",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a600fb69a2394d5536a92a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "yardi",
      "external_id": "128189114",
      "title": "Trash compactor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3c6b30d7b3db809bb3f7c31c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-d6d5-713e-b289-6cbbb989508e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with apartment buildings in the background.",
        "public_id": "01a04a11-d6d5-713e-b289-6cbbb989508e",
        "storage_key": "property/6767906449167661/01a04a11-d6d5-713e-b289-6cbbb989508e.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by the modern architecture of our apartment community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-013(1).jpg"
    },
    {
      "id": "ec_193fd03654699c93985fe6ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-eab5-721b-bdf0-848e8e3bc9b6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "01a04a11-eab5-721b-bdf0-848e8e3bc9b6",
        "storage_key": "property/6767906449167661/01a04a11-eab5-721b-bdf0-848e8e3bc9b6.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A spacious and updated kitchen featuring stainless steel appliances, sleek cabinetry, and ample counter space, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-006.jpg"
    },
    {
      "id": "ec_0df2bc6dd993ce30acf02e3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-e8be-755c-a064-3e14e7f552fb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island.",
        "public_id": "01a04a11-e8be-755c-a064-3e14e7f552fb",
        "storage_key": "property/6767906449167661/01a04a11-e8be-755c-a064-3e14e7f552fb.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring stainless steel appliances, a spacious island, and ample cabinet storage.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-001.jpg"
    },
    {
      "id": "ec_bf0cc408d500868a76654883",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-e842-7311-9dc8-cf9b745f4bc6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and in-unit washer and dryer.",
        "public_id": "01a04a11-e842-7311-9dc8-cf9b745f4bc6",
        "storage_key": "property/6767906449167661/01a04a11-e842-7311-9dc8-cf9b745f4bc6.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, sleek granite countertops, a deep sink, and a full suite of stainless steel appliances, complemented by an in-unit washer and dryer for ultimate convenience.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and in-unit washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-008.jpg"
    },
    {
      "id": "ec_38b4b2a0263c4447fae0721e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-e867-73fd-99c9-4b6554ffa580.webp",
      "image_media": {
        "alt_text": "Kitchen with island, dishwasher, sink, pendant lights, and washer/dryer closet.",
        "public_id": "01a04a11-e867-73fd-99c9-4b6554ffa580",
        "storage_key": "property/6767906449167661/01a04a11-e867-73fd-99c9-4b6554ffa580.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a spacious island with a sink and dishwasher, elegant pendant lighting, and a convenient in-unit washer and dryer.",
      "link": "false",
      "alt_text": "Kitchen with island, dishwasher, sink, pendant lights, and washer/dryer closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-004.jpg"
    },
    {
      "id": "ec_1aba09912304c96b6fbd9c7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-e867-73fd-99c9-46241dbc885d.webp",
      "image_media": {
        "alt_text": "Open concept living area with kitchen island and modern appliances.",
        "public_id": "01a04a11-e867-73fd-99c9-46241dbc885d",
        "storage_key": "property/6767906449167661/01a04a11-e867-73fd-99c9-46241dbc885d.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly connected to a modern kitchen, featuring a large island, stainless steel appliances, and ample cabinet space.",
      "link": "false",
      "alt_text": "Open concept living area with kitchen island and modern appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-005.jpg"
    },
    {
      "id": "ec_974280a20194fb731bb608d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-f499-7144-baf0-e698b8b3d030.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and island.",
        "public_id": "01a04a11-f499-7144-baf0-e698b8b3d030",
        "storage_key": "property/6767906449167661/01a04a11-f499-7144-baf0-e698b8b3d030.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, granite countertops, stainless steel appliances, and an island perfect for meal preparation and casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-003.jpg"
    },
    {
      "id": "ec_e2e6c9a66a2f2366abdb7f0a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-f579-7767-a3fd-c4a1cf1d6ae5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island.",
        "public_id": "01a04a11-f579-7767-a3fd-c4a1cf1d6ae5",
        "storage_key": "property/6767906449167661/01a04a11-f579-7767-a3fd-c4a1cf1d6ae5.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, sleek granite countertops, stainless steel appliances, and a large island perfect for meal prep and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-007.jpg"
    },
    {
      "id": "ec_b8d0ba32fd5d5452191eafb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-35ee-7798-a5d2-ac54d246dce5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a granite island.",
        "public_id": "019ffd19-35ee-7798-a5d2-ac54d246dce5",
        "storage_key": "property/6767906449167661/019ffd19-35ee-7798-a5d2-ac54d246dce5.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, a sleek subway tile backsplash, stainless steel appliances, and a large granite-topped island with a deep sink.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a granite island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-002.jpg"
    },
    {
      "id": "ec_1b27d908a9fe27b538d6f90b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-f609-730f-8b18-1e5b32d86e4f.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with weight machines and cardio equipment.",
        "public_id": "01a04a11-f609-730f-8b18-1e5b32d86e4f",
        "storage_key": "property/6767906449167661/01a04a11-f609-730f-8b18-1e5b32d86e4f.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of strength training and cardio equipment for a complete workout experience.",
      "link": "false",
      "alt_text": "Well-equipped fitness center with weight machines and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-011.jpg"
    },
    {
      "id": "ec_6c89f05058f2b7b359d46af2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-f6b9-72a1-acd0-88673d34f9e9.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, stationary bikes, and weight equipment with a window view of the pool.",
        "public_id": "01a04a11-f6b9-72a1-acd0-88673d34f9e9",
        "storage_key": "property/6767906449167661/01a04a11-f6b9-72a1-acd0-88673d34f9e9.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, weights, and spin bikes. Enjoy a workout with a view of our sparkling pool.",
      "link": "false",
      "alt_text": "Gym with treadmills, stationary bikes, and weight equipment with a window view of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-012.jpg"
    },
    {
      "id": "ec_7864866aebf4ca37311f25be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-f819-70fc-938b-dc5164eef3e8.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station and green space at apartment complex.",
        "public_id": "01a04a11-f819-70fc-938b-dc5164eef3e8",
        "storage_key": "property/6767906449167661/01a04a11-f819-70fc-938b-dc5164eef3e8.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and entertaining at our modern grilling station, surrounded by lush landscaping and scenic views.",
      "link": "false",
      "alt_text": "Outdoor grilling station and green space at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-010.jpg"
    },
    {
      "id": "ec_341a4a41e5f0dcac7acf31dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a11-ffea-74a8-9939-fcfa591d5b79.webp",
      "image_media": {
        "alt_text": "Dog park area with fence and signage",
        "public_id": "01a04a11-ffea-74a8-9939-fcfa591d5b79",
        "storage_key": "property/6767906449167661/01a04a11-ffea-74a8-9939-fcfa591d5b79.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Community",
      "description": "On-site dog park for residents to exercise their pets.",
      "link": "false",
      "alt_text": "Dog park area with fence and signage",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-018.jpg"
    },
    {
      "id": "ec_d125471c109667537799bcf3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a12-016f-7519-a043-53b5cff62b26.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station and pool area with modern apartment buildings.",
        "public_id": "01a04a12-016f-7519-a043-53b5cff62b26",
        "storage_key": "property/6767906449167661/01a04a12-016f-7519-a043-53b5cff62b26.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a community grilling station and a refreshing swimming pool, surrounded by contemporary apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor grilling station and pool area with modern apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-009.jpg"
    },
    {
      "id": "ec_863acc7c403073c8978bbff2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a12-0158-75ed-974b-8631970ccf5f.webp",
      "image_media": {
        "alt_text": "Lobby area with couches, coffee table, and decorative elements.",
        "public_id": "01a04a12-0158-75ed-974b-8631970ccf5f",
        "storage_key": "property/6767906449167661/01a04a12-0158-75ed-974b-8631970ccf5f.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Lobby area with couches, coffee table, and decorative elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-015.jpg"
    },
    {
      "id": "ec_7da8b68e1d8e96961fe7d379",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a12-051b-764f-aead-75dae955b07c.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with plush sectional sofa, modern coffee table, and stylish armchairs.",
        "public_id": "01a04a12-051b-764f-aead-75dae955b07c",
        "storage_key": "property/6767906449167661/01a04a12-051b-764f-aead-75dae955b07c.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lounge, featuring comfortable seating and elegant decor, perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Luxurious lounge area with plush sectional sofa, modern coffee table, and stylish armchairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-014.jpg"
    },
    {
      "id": "ec_f78c2387dddfdd4cca28d045",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a12-05df-73af-b55d-1610b65348ea.webp",
      "image_media": {
        "alt_text": "Gourmet community kitchen with stainless steel appliances, granite countertops, and bar seating.",
        "public_id": "01a04a12-05df-73af-b55d-1610b65348ea",
        "storage_key": "property/6767906449167661/01a04a12-05df-73af-b55d-1610b65348ea.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy our sleek, modern community kitchen, perfect for entertaining guests or casual gatherings. Featuring premium appliances and ample counter space.",
      "link": "false",
      "alt_text": "Gourmet community kitchen with stainless steel appliances, granite countertops, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-017.jpg"
    },
    {
      "id": "ec_d3d250a4d8104d3726cb3e7a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a12-0d7b-7145-a897-afad073b2858.webp",
      "image_media": {
        "alt_text": "Open concept living area with a kitchen island and bar seating.",
        "public_id": "01a04a12-0d7b-7145-a897-afad073b2858",
        "storage_key": "property/6767906449167661/01a04a12-0d7b-7145-a897-afad073b2858.webp",
        "width": 1998,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area featuring a modern kitchen with a large island, bar seating, and elegant finishes.",
      "link": "false",
      "alt_text": "Open concept living area with a kitchen island and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-016(1).jpg"
    },
    {
      "id": "ec_deb9ebf22736c9e0208c49a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a04a12-0e85-72ca-8d43-86cead54dfa2.webp",
      "image_media": {
        "alt_text": "Emilia apartment building exterior with blue and tan siding, balconies, and a parking lot.",
        "public_id": "01a04a12-0e85-72ca-8d43-86cead54dfa2",
        "storage_key": "property/6767906449167661/01a04a12-0e85-72ca-8d43-86cead54dfa2.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Exterior view of the Emilia apartment building, featuring modern blue and tan siding, private balconies, and ample parking.",
      "link": "false",
      "alt_text": "Emilia apartment building exterior with blue and tan siding, balconies, and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Emilia-POI-019(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_070bbf6a-7d58-4605-81d1-23c784bf87c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Luciano Ristorante Italiano - Fair Oaks",
      "poi_type": "Restaurants",
      "poi_address": "27650 W Interstate 10 Frontage Rd Ste 101, Boerne, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-eac3-7070-b138-f18d12a5d440.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-eac3-7070-b138-f18d12a5d440",
        "storage_key": "property/6767906449167661/019ffd1a-eac3-7070-b138-f18d12a5d440.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lucianonapaoaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16254763495412529904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luciano-ristorante-italiano---fair-oaks",
      "poi_latitude": "29.7091941",
      "poi_longitude": "-98.6570357",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 830-357-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJseOzTYR7XIYR8PoMFEeFlOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_84884575-e546-4dec-9c8b-4a9a5a57b53b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "El Mirasol At Napa Oaks",
      "poi_type": "Restaurants",
      "poi_address": "27650 I-10 Ste 115, Boerne, TX 78015, USA",
      "poi_short_description": "Posh restaurant serving Tex-Mex staples like enchiladas, fajitas and tacos alongside margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-e714-732f-b009-1b2767925088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-e714-732f-b009-1b2767925088",
        "storage_key": "property/6767906449167661/019ffd1a-e714-732f-b009-1b2767925088.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.elmirasolsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3391790114506906269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-mirasol-at-napa-oaks",
      "poi_latitude": "29.7098924",
      "poi_longitude": "-98.6574951",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-957-1930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTybKJ8d7XIYRnZrdfyMPEi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fc580533-57bc-4e3f-b376-90c60a24534e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Toroko Sushi",
      "poi_type": "Restaurants",
      "poi_address": "9091 Fair Oaks Pkwy, Fair Oaks Ranch, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-1e7b-730d-8dd9-bd348196bc98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-1e7b-730d-8dd9-bd348196bc98",
        "storage_key": "property/6767906449167661/01a025fc-1e7b-730d-8dd9-bd348196bc98.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://toroko-sushi-fairoaks.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5423414013863060003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toroko-sushi",
      "poi_latitude": "29.7209887",
      "poi_longitude": "-98.6648075",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-257-6129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFet-1zFxXIYRI-Iupk_WQ0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_22c12b25-68f1-4130-872b-1fe805403394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Fair Oaks Roost",
      "poi_type": "Restaurants",
      "poi_address": "9091 Fair Oaks Pkwy #201, Boerne, TX 78015, USA",
      "poi_short_description": "Casual, sports-centric hangout with pub grub, beer, cocktails, TVs, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-1ee3-7659-b93e-3026fb162d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-1ee3-7659-b93e-3026fb162d6b",
        "storage_key": "property/6767906449167661/01a025fc-1ee3-7659-b93e-3026fb162d6b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2588830903396431038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-oaks-roost",
      "poi_latitude": "29.7205916",
      "poi_longitude": "-98.6646978",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-233-8443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWzrZwBxXIYRvnR_jP1f7SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_e99fe1ed-7cfc-4f2d-918e-18471d10192b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Mikey's Chicken & Tavern",
      "poi_type": "Restaurants",
      "poi_address": "25930 I-10, Boerne, TX 78006, USA",
      "poi_short_description": "Vibrant restaurant & bar featuring a menu of burgers, pizzas, wings & more, plus a kids' play area.",
      "poi_long_description": "Vibrant restaurant & bar featuring a menu of burgers, pizzas, wings & more, plus a kids' play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-1d90-712b-8fcf-9c006279124e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-1d90-712b-8fcf-9c006279124e",
        "storage_key": "property/6767906449167661/01a025fc-1d90-712b-8fcf-9c006279124e.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://mikeyschicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12999234427299361943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mikeys-chicken--tavern",
      "poi_latitude": "29.6861354",
      "poi_longitude": "-98.6413863",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-698-6672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQz14ZUllXIYRl_Q0t9aOZrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_bfbf571b-03ea-47fb-af55-9dfb7bfb6b65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "The Roundup Outdoor Music Venue",
      "poi_type": "Entertainment",
      "poi_address": "531 FM 3351, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1b-4934-77ab-b771-08229440a09c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1b-4934-77ab-b771-08229440a09c",
        "storage_key": "property/6767906449167661/019ffd1b-4934-77ab-b771-08229440a09c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.therounduptx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12590547276813078214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-roundup-outdoor-music-venue",
      "poi_latitude": "29.9032375",
      "poi_longitude": "-98.566137",
      "poi_miles_from_property": "17.8",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 830-428-3231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ3_4Y0V_XIYRxo40agqcuq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_e4c2b5e8-cf91-476a-8c46-f0b24c7de06c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Richter Tavern",
      "poi_type": "Restaurants",
      "poi_address": "153 S Main St, Boerne, TX 78006, USA",
      "poi_short_description": "Established in 1869, this eatery with a 1920s industrial vibe serves cocktails, wine, and American bites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-e14a-7397-8165-0f598e5ec9ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-e14a-7397-8165-0f598e5ec9ce",
        "storage_key": "property/6767906449167661/019ffd1a-e14a-7397-8165-0f598e5ec9ce.webp",
        "width": 1280,
        "height": 1161
      },
      "poi_business_url": "https://richterboerne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5809770102928360468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richter-tavern",
      "poi_latitude": "29.793363",
      "poi_longitude": "-98.731143",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-331-2675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8Kg9AZ3XIYRFMS6iyBzoFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_98779969-0d2f-4eb6-b216-8f4e8e689eab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Cibolo Creek Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "448 S Main St, Boerne, TX 78006, USA",
      "poi_short_description": "Family-owned, kid-friendly brewpub featuring craft brews & casual eats, plus shaded patio seating.",
      "poi_long_description": "Family-owned, kid-friendly brewpub featuring craft brews & casual eats, plus shaded patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-db7c-759a-afab-f5113a150153.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-db7c-759a-afab-f5113a150153",
        "storage_key": "property/6767906449167661/019ffd1a-db7c-759a-afab-f5113a150153.webp",
        "width": 1080,
        "height": 749
      },
      "poi_business_url": "http://www.cibolocreekbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10456582077268488963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cibolo-creek-brewing-co",
      "poi_latitude": "29.7900856",
      "poi_longitude": "-98.7300795",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-816-5275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77fTwrl2XIYRA_NNeP89HZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_194e1eb8-58c4-43a8-a97c-7ae690e5d795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne Taco House",
      "poi_type": "Restaurants",
      "poi_address": "470 S Main St Ste 200, Boerne, TX 78006, USA",
      "poi_short_description": "Homey restaurant serving up Mexican grub such as street-style & breakfast tacos & quesadillas.",
      "poi_long_description": "Homey restaurant serving up Mexican grub such as street-style & breakfast tacos & quesadillas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-e163-73da-9eea-5bd02dcd298b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-e163-73da-9eea-5bd02dcd298b",
        "storage_key": "property/6767906449167661/019ffd1a-e163-73da-9eea-5bd02dcd298b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boernetacohouse.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13944067046531762440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-taco-house",
      "poi_latitude": "29.7898107",
      "poi_longitude": "-98.7298948",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-331-2874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJte8lfrt2XIYRCInBmBlHg8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b7cfd1d8-d339-4eda-957c-e91061cd4abf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "The Daily Grind",
      "poi_type": "Restaurants",
      "poi_address": "143 S Main St, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-1f59-7302-b456-8861f44bb03d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-1f59-7302-b456-8861f44bb03d",
        "storage_key": "property/6767906449167661/01a025fc-1f59-7302-b456-8861f44bb03d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12093964157412112962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-daily-grind",
      "poi_latitude": "29.7934642",
      "poi_longitude": "-98.7313185",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cab-7506-8331-bbbd198338a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cab-7506-8331-bbbd198338a3",
        "storage_key": "property/6767906449167661/01a025fc-4cab-7506-8331-bbbd198338a3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJq6rGYLl2XIYRQvraGFNk1qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_9e90773c-5eac-4e7f-b6ba-926f52f452bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "The Dodging Duck Brewhaus",
      "poi_type": "Restaurants",
      "poi_address": "402 River Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Country brewpub offering house beers, global comfort-food menu & patio overlooking duck-filled pond.",
      "poi_long_description": "Country brewpub offering house beers, global comfort-food menu & patio overlooking duck-filled pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-dbb1-77d9-b50d-ca8c68ddcfeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-dbb1-77d9-b50d-ca8c68ddcfeb",
        "storage_key": "property/6767906449167661/019ffd1a-dbb1-77d9-b50d-ca8c68ddcfeb.webp",
        "width": 960,
        "height": 584
      },
      "poi_business_url": "http://www.dodgingduck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672998708417579001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-dodging-duck-brewhaus",
      "poi_latitude": "29.7896312",
      "poi_longitude": "-98.7259439",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-248-3825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3Mf_8d2XIYR-cemsF-uXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_1510ed67-9580-45c9-857e-4c190d52d40d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Sunny's",
      "poi_type": "Restaurants",
      "poi_address": "518 River Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-dd72-7721-ac57-b21d09786755.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-dd72-7721-ac57-b21d09786755",
        "storage_key": "property/6767906449167661/019ffd1a-dd72-7721-ac57-b21d09786755.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "https://www.sunnysbrunch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10047692261738163466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnys",
      "poi_latitude": "29.7897952",
      "poi_longitude": "-98.7243966",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-266-0498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYYDUo93XIYRCi1YieCScIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_b95166df-dea5-4af2-806f-1e6a051c2cb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Salvador DOBBS",
      "poi_type": "Restaurants",
      "poi_address": "512 River Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Cozy hangout for live music, beers and cocktails, with outdoor seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-62fd-72bc-9721-bc9705491477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-62fd-72bc-9721-bc9705491477",
        "storage_key": "property/6767906449167661/019ffd1c-62fd-72bc-9721-bc9705491477.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://salvadordobbs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15269661765392886713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salvador-dobbs",
      "poi_latitude": "29.7898216",
      "poi_longitude": "-98.7246856",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-249-5508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cac-711a-b083-22a0bd80a73f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cac-711a-b083-22a0bd80a73f",
        "storage_key": "property/6767906449167661/01a025fc-4cac-711a-b083-22a0bd80a73f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7e538d2XIYRuWubNnm86NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_02f23d53-b3fc-411b-8c03-77d4fdec41a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Hungry Horse Restaurant and Catering",
      "poi_type": "Restaurants",
      "poi_address": "109 Saunders St, Boerne, TX 78006, USA",
      "poi_short_description": "Catfish & chicken-fried steak helm the homestyle fare at this simple cafe with adjustable portions.",
      "poi_long_description": "Catfish & chicken-fried steak helm the homestyle fare at this simple cafe with adjustable portions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-22dc-72b8-aa86-473c44f0500b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-22dc-72b8-aa86-473c44f0500b",
        "storage_key": "property/6767906449167661/01a025fc-22dc-72b8-aa86-473c44f0500b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hungryhorsehillcountry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2102227865780816147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hungry-horse-restaurant-and-catering",
      "poi_latitude": "29.7942244",
      "poi_longitude": "-98.7297753",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-816-8989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUicO7l2XIYREwnLGBudLB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_21344d73-b9a3-4989-8191-c3b665d1ad21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Indulge",
      "poi_type": "Restaurants",
      "poi_address": "21 Truss Dr, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-20d1-73ba-a7b4-1404f6ca9665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-20d1-73ba-a7b4-1404f6ca9665",
        "storage_key": "property/6767906449167661/01a025fc-20d1-73ba-a7b4-1404f6ca9665.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.indulgetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2765994735809683208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indulge",
      "poi_latitude": "29.813771",
      "poi_longitude": "-98.6228749",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 31 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 830-336-4727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cac-711a-b083-22a0bd80a73f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cac-711a-b083-22a0bd80a73f",
        "storage_key": "property/6767906449167661/01a025fc-4cac-711a-b083-22a0bd80a73f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyajI4x5XIYRCF-Jro7JYiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_12cf1051-252b-436e-ba76-e8e3aa2d8aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Fischer's Neighborhood Market #37",
      "poi_type": "Shopping & Retail",
      "poi_address": "29202 Ralph Fair Rd, Fair Oaks Ranch, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-240c-729d-acc7-7521533d9634.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-240c-729d-acc7-7521533d9634",
        "storage_key": "property/6767906449167661/01a025fc-240c-729d-acc7-7521533d9634.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fischersmkt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5017912094855983904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fischers-neighborhood-market-37",
      "poi_latitude": "29.731906",
      "poi_longitude": "-98.6229084",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 830-582-8542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9f-7274-b374-9d6ab069f86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9f-7274-b374-9d6ab069f86e",
        "storage_key": "property/6767906449167661/01a025fc-4c9f-7274-b374-9d6ab069f86e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJl-U6ZJ97XIYRIPMG2HY0o0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7f068052-5f88-4a3d-9fe5-6b5abf31e76a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Transportation & Transit",
      "poi_address": "29202 Ralph Fair Rd, Fair Oaks Ranch, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-2469-774d-bb0e-50aa529456c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-2469-774d-bb0e-50aa529456c6",
        "storage_key": "property/6767906449167661/01a025fc-2469-774d-bb0e-50aa529456c6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10071750-29202-ralph-fair-rd/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=13596249506337504575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "29.731494",
      "poi_longitude": "-98.62308",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 830-672-9574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9d-72ec-8a98-9e778912a8f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9d-72ec-8a98-9e778912a8f1",
        "storage_key": "property/6767906449167661/01a025fc-4c9d-72ec-8a98-9e778912a8f1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxDSv_t6XIYRP73T1uOUr7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_7c1f75a0-2b83-4517-bc7d-52cbbd3cae6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Valero",
      "poi_type": "Transportation & Transit",
      "poi_address": "31700 I-10, Boerne, TX 78006, USA",
      "poi_short_description": "Gas station chain supplying diesel and gasoline plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-24d7-7086-a39d-912d6bcd55ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-24d7-7086-a39d-912d6bcd55ff",
        "storage_key": "property/6767906449167661/01a025fc-24d7-7086-a39d-912d6bcd55ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valero.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=926859880909793411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.75608",
      "poi_longitude": "-98.7052494",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 830-755-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9d-72ec-8a98-9e778912a8f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9d-72ec-8a98-9e778912a8f1",
        "storage_key": "property/6767906449167661/01a025fc-4c9d-72ec-8a98-9e778912a8f1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJA8Yv8x9xXIYRg2gwpibe3Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_dc8f0bdd-6cf9-4692-bd4d-f4d9ae6ca532",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Flagstop Café",
      "poi_type": "Restaurants",
      "poi_address": "28425 I-10, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-2b7f-7288-9e57-b4ecbc868879.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-2b7f-7288-9e57-b4ecbc868879",
        "storage_key": "property/6767906449167661/01a025fc-2b7f-7288-9e57-b4ecbc868879.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://flagstop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14410466645452643079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flagstop-caf",
      "poi_latitude": "29.719416",
      "poi_longitude": "-98.667223",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2faf-725e-b4fd-24a763916e88",
        "storage_key": "property/6767906449167661/019ffd19-2faf-725e-b4fd-24a763916e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ylsZnFwXIYRB9vRaRBD_Mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_dfebe4cf-a5ca-480e-a0bb-f0ce53377d22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Exxon",
      "poi_type": "Transportation & Transit",
      "poi_address": "440 W Bandera Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Gas station in a chain offering diesel as well as gas, and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-29cb-71e1-9575-4d0899700155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-29cb-71e1-9575-4d0899700155",
        "storage_key": "property/6767906449167661/01a025fc-29cb-71e1-9575-4d0899700155.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.exxonmobilfuels.com/en/find-gas-station/200313490",
      "poi_directions_map_url": "https://maps.google.com/?cid=5859080141479277532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxon",
      "poi_latitude": "29.7809485",
      "poi_longitude": "-98.7363806",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-249-3287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9d-72ec-8a98-9e778912a8f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9d-72ec-8a98-9e778912a8f1",
        "storage_key": "property/6767906449167661/01a025fc-4c9d-72ec-8a98-9e778912a8f1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9PterJ2XIYR3PNqj1iiT1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_5a628827-7b26-4f24-aacd-f05d7ed0a15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "420 W Bandera Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-a60e-75e4-bbfa-dcc51d6cbc6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-a60e-75e4-bbfa-dcc51d6cbc6f",
        "storage_key": "property/6767906449167661/019ffd1c-a60e-75e4-bbfa-dcc51d6cbc6f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/boerne/boerne-h-e-b-plus--621?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=15832780567225257439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "29.781868",
      "poi_longitude": "-98.733758",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 37 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-816-2394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-3016-7471-b4bb-91a06562ef3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-3016-7471-b4bb-91a06562ef3b",
        "storage_key": "property/6767906449167661/019ffd19-3016-7471-b4bb-91a06562ef3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJufAhyLN2XIYR300rTApWuds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_592baf83-d2b5-45eb-a997-f95cdd2d9f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1381 S Main St, Boerne, TX 78006, USA",
      "poi_short_description": "Department store carrying products such as apparel, toys, electronics, appliances, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-e8b9-75fd-96ec-b8131f4635b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-e8b9-75fd-96ec-b8131f4635b3",
        "storage_key": "property/6767906449167661/019ffd1a-e8b9-75fd-96ec-b8131f4635b3.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1126-boerne-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5696268956138567494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.7787689",
      "poi_longitude": "-98.7245444",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-249-6195",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fbb-73bd-8a1d-7754d773781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fbb-73bd-8a1d-7754d773781f",
        "storage_key": "property/6767906449167661/019ffd19-2fbb-73bd-8a1d-7754d773781f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8U9bysp2XIYRRne5e282DU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_28714322-0e35-4c08-9cf0-c4945eb9e4c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "633 W Bandera Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-2b09-73fd-a1f9-aa14438a4028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-2b09-73fd-a1f9-aa14438a4028",
        "storage_key": "property/6767906449167661/01a025fc-2b09-73fd-a1f9-aa14438a4028.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Boerne/TX/Boerne/78006/6556?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9849121125329326706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "29.77783579999999",
      "poi_longitude": "-98.7411896",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-249-2834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fbb-73bd-8a1d-7754d773781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fbb-73bd-8a1d-7754d773781f",
        "storage_key": "property/6767906449167661/019ffd19-2fbb-73bd-8a1d-7754d773781f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP1n6f7J2XIYRctIMCXsbr4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_78e3c497-f17a-4da5-8764-646df02eedaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Main Square Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "123 N Main St, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4954171263429424492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-square-foods",
      "poi_latitude": "29.7944255",
      "poi_longitude": "-98.7318278",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-249-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9f-7274-b374-9d6ab069f86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9f-7274-b374-9d6ab069f86e",
        "storage_key": "property/6767906449167661/01a025fc-4c9f-7274-b374-9d6ab069f86e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJyRoXvSt0XIYRbLUoCYTAwEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_e724a106-00ab-412f-9806-06523f690ea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "River Road Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "910 River Rd STE 103, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-2be8-7652-add2-2cd49c002ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-2be8-7652-add2-2cd49c002ebd",
        "storage_key": "property/6767906449167661/01a025fc-2be8-7652-add2-2cd49c002ebd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverroadpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7371631700619869222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-road-pharmacy",
      "poi_latitude": "29.7892932",
      "poi_longitude": "-98.7194265",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-816-5312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9e-720e-bbbf-4de1883e421e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9e-720e-bbbf-4de1883e421e",
        "storage_key": "property/6767906449167661/01a025fc-4c9e-720e-bbbf-4de1883e421e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9feXM92XIYRJrx0ovlLTWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ee2318fc-7851-4f48-b4b4-39ca22be27ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Fair Oaks Ranch Elementary",
      "poi_type": "Education",
      "poi_address": "29085 Ralph Fair Rd, Fair Oaks Ranch, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.boerneisd.net/FORES",
      "poi_directions_map_url": "https://maps.google.com/?cid=7394897892397527532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-oaks-ranch-elementary",
      "poi_latitude": "29.7282422",
      "poi_longitude": "-98.6242312",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 830-357-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-z654fp6XIYR7LGjCnT0n2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ad865b43-ae35-4f2c-81e8-19d8dc8a5e6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Van Raub",
      "poi_type": "Education",
      "poi_address": "8776 Dietz Elkhorn Rd, Fair Oaks Ranch, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://boerne-isd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1551971612006666526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-raub",
      "poi_latitude": "29.7305016",
      "poi_longitude": "-98.6581163",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 830-357-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhZ4MI4J6XIYRHtElW_W1iRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4a68f71b-949d-47b0-9469-9c92962a8158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Cibolo Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "300 Herff Ranch Blvd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-f668-777b-b95f-a883ff7315d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-f668-777b-b95f-a883ff7315d8",
        "storage_key": "property/6767906449167661/019ffd1a-f668-777b-b95f-a883ff7315d8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cces.boerneisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295457966104974459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cibolo-creek-elementary-school",
      "poi_latitude": "29.7829358",
      "poi_longitude": "-98.6979115",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-357-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa8I-iSt3XIYRexR7_12sPmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2326abf6-0518-4b05-8b3b-b66653000dec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne Middle School South",
      "poi_type": "Education",
      "poi_address": "10 Cascade Cavern, Boerne, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.boerneisd.net/bmss",
      "poi_directions_map_url": "https://maps.google.com/?cid=12090494085091320788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-middle-school-south",
      "poi_latitude": "29.7601232",
      "poi_longitude": "-98.703817",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 830-357-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZZ9tWDlxXIYR1GPU7E8Qyqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_46beb0b4-c2b8-4404-ab1d-66664a600537",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne Middle School North",
      "poi_type": "Education",
      "poi_address": "240 Johns Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-f560-75bf-99ad-0bcca85f7284.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-f560-75bf-99ad-0bcca85f7284",
        "storage_key": "property/6767906449167661/019ffd1a-f560-75bf-99ad-0bcca85f7284.webp",
        "width": 1023,
        "height": 682
      },
      "poi_business_url": "http://www.boerne-isd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=132430183940819908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-middle-school-north",
      "poi_latitude": "29.7957837",
      "poi_longitude": "-98.7365306",
      "poi_miles_from_property": "13.5",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-357-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ48q8vbx2XIYRxAtV94x81gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_29d19f0a-ad74-4de6-b060-3c891fee1e39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne High School",
      "poi_type": "Education",
      "poi_address": "1 Greyhound Ln, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-f1bb-7334-bab9-7d4d802e6d1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-f1bb-7334-bab9-7d4d802e6d1e",
        "storage_key": "property/6767906449167661/019ffd1a-f1bb-7334-bab9-7d4d802e6d1e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.boerneisd.net/bhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=12564677120094786132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-high-school",
      "poi_latitude": "29.7994802",
      "poi_longitude": "-98.7093769",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-357-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE-JtU9x2XIYRVFK6LEWzXq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cb69c624-6c77-42f1-8e62-40aaf528b26b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne-Samuel V. Champion High School",
      "poi_type": "Education",
      "poi_address": "201 Charger Blvd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-f238-71da-b7a9-90ae36e90c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-f238-71da-b7a9-90ae36e90c7e",
        "storage_key": "property/6767906449167661/019ffd1a-f238-71da-b7a9-90ae36e90c7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.boerne-isd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10701619307682460705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-samuel-v-champion-high-school",
      "poi_latitude": "29.7860479",
      "poi_longitude": "-98.7049134",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-357-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCwSL_tZ2XIYRIfTfiw_Kg5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d98d34aa-4fc5-46a5-9625-cf14b204606c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne KinderCare",
      "poi_type": "Education",
      "poi_address": "18 Scenic Loop Rd #100, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-2faf-7474-a74f-f9fc8b743a78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-2faf-7474-a74f-f9fc8b743a78",
        "storage_key": "property/6767906449167661/01a025fc-2faf-7474-a74f-f9fc8b743a78.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/boerne/tx/302171?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MjAyMjQ1OTAwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17747827428053571587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-kindercare",
      "poi_latitude": "29.7486341",
      "poi_longitude": "-98.7062144",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 830-981-4343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4zVdzk9xXIYRA1gRiAPzTPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_d9f4afdd-1a06-405e-a556-2c26bef41d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Mini Texans",
      "poi_type": "Education",
      "poi_address": "104 Woods of Boerne Blvd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1b-130a-723b-b115-368e8b01faf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1b-130a-723b-b115-368e8b01faf4",
        "storage_key": "property/6767906449167661/019ffd1b-130a-723b-b115-368e8b01faf4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cadence-education.com/locations/tx/boerne/396?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=13807387025323361763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mini-texans",
      "poi_latitude": "29.7903194",
      "poi_longitude": "-98.706459",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-308-7744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU4o4nNd2XIYR44W8SFixnb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_35c14e47-c5a2-4f20-8c87-79e5f563cfef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Schreiner University",
      "poi_type": "Education",
      "poi_address": "2100 Memorial Blvd, Kerrville, TX 78028, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-3213-7721-8b38-5161815df836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-3213-7721-8b38-5161815df836",
        "storage_key": "property/6767906449167661/01a025fc-3213-7721-8b38-5161815df836.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://schreiner.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=385070413855912607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schreiner-university",
      "poi_latitude": "30.0316548",
      "poi_longitude": "-99.129298",
      "poi_miles_from_property": "47",
      "poi_walking_minutes": "17 hours 10 mins",
      "poi_biking_minutes": "3 hours 54 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "+1 800-343-4919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx5K5_zPjW4YRn_JkT4ALWAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fe54a3a9-e4ac-406b-b9f8-42271b23d6bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "AMC Boerne 11",
      "poi_type": "Entertainment",
      "poi_address": "205 Old San Antonio Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Standard movie theater featuring discount tickets for new releases as well as concession specials.",
      "poi_long_description": "Standard movie theater featuring discount tickets for new releases as well as concession specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-f8d2-731a-8b5f-f87d05511f4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-f8d2-731a-8b5f-f87d05511f4e",
        "storage_key": "property/6767906449167661/019ffd1a-f8d2-731a-8b5f-f87d05511f4e.webp",
        "width": 565,
        "height": 317
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/san-antonio/amc-boerne-11?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3620284977617440978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-boerne-11",
      "poi_latitude": "29.7586539",
      "poi_longitude": "-98.7043162",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 830-549-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9d-72ec-8a98-a17d599f7629.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9d-72ec-8a98-a17d599f7629",
        "storage_key": "property/6767906449167661/01a025fc-4c9d-72ec-8a98-a17d599f7629.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbslUSBxXIYR0hCSjAHWPTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_8fb23a8d-598a-4321-9444-8c3ed6768a28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Cibolo Center for Conservation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "140 City Park Rd, Boerne, TX 78006, USA",
      "poi_short_description": "This educational center aims to bring nature alive through hands on-farm activities.",
      "poi_long_description": "This educational center aims to bring nature alive through hands on-farm activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-327d-769e-a7aa-51dc0d8b21c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-327d-769e-a7aa-51dc0d8b21c1",
        "storage_key": "property/6767906449167661/01a025fc-327d-769e-a7aa-51dc0d8b21c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cibolo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17967421470106126430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cibolo-center-for-conservation",
      "poi_latitude": "29.7816485",
      "poi_longitude": "-98.7090969",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-249-4616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQphHdR2XIYRXghnr6EaWfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_bfe97052-d401-4f71-990f-0dfb25d6d2b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Cascade Caverns",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "226 Cascade Cavern, Boerne, TX 78015, USA",
      "poi_short_description": "Tours of a cave with a 70-ft. ceiling on a 104-acre site with tent camping, trails & wildlife.",
      "poi_long_description": "Tours of a cave with a 70-ft. ceiling on a 104-acre site with tent camping, trails & wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd18-edb1-70d7-a643-b0e9fb26224a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd18-edb1-70d7-a643-b0e9fb26224a",
        "storage_key": "property/6767906449167661/019ffd18-edb1-70d7-a643-b0e9fb26224a.webp",
        "width": 553,
        "height": 1280
      },
      "poi_business_url": "http://www.cascadecaverns.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2338545666714961919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cascade-caverns",
      "poi_latitude": "29.7636976",
      "poi_longitude": "-98.68031",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-755-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2k8U79wXIYR_weTy-QudCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_adc244b7-7ca9-41ed-8c6f-98ca9e78135d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Cave Without A Name",
      "poi_type": "Entertainment",
      "poi_address": "325 Kreutzberg Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Scenic cavern open since 1939 for tours of unusual geological formations & occasional live concerts.",
      "poi_long_description": "Scenic cavern open since 1939 for tours of unusual geological formations & occasional live concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1b-1b92-75fe-8961-469029642510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1b-1b92-75fe-8961-469029642510",
        "storage_key": "property/6767906449167661/019ffd1b-1b92-75fe-8961-469029642510.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cavewithoutaname.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12420750023326875042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cave-without-a-name",
      "poi_latitude": "29.8862892",
      "poi_longitude": "-98.61844",
      "poi_miles_from_property": "22.7",
      "poi_walking_minutes": "8 hours 17 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 830-537-4212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbEXRvSHW4YRor1SmFZeX6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_42bcb5d9-9876-40d1-95dd-2737ff8a2f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Agricultural Museum and Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "102 City Park Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-35a0-734f-a7af-1c842236243d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-35a0-734f-a7af-1c842236243d",
        "storage_key": "property/6767906449167661/01a025fc-35a0-734f-a7af-1c842236243d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.theagricultural.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17548541745991424593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "agricultural-museum-and-arts-center",
      "poi_latitude": "29.7875247",
      "poi_longitude": "-98.7134384",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-445-1080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cc7-7299-825c-3be9a0150f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cc7-7299-825c-3be9a0150f23",
        "storage_key": "property/6767906449167661/01a025fc-4cc7-7299-825c-3be9a0150f23.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ460ZdhJ3XIYRUZru573xiPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b65d7931-353a-4fb0-b92a-371524ae84e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne Community Theatre",
      "poi_type": "Entertainment",
      "poi_address": "907 E Blanco Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-3213-7721-8b38-55ea4fe6cc21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-3213-7721-8b38-55ea4fe6cc21",
        "storage_key": "property/6767906449167661/01a025fc-3213-7721-8b38-55ea4fe6cc21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boernetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=912196828142409630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-community-theatre",
      "poi_latitude": "29.7969303",
      "poi_longitude": "-98.7247695",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-249-9166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9uy6sB2XIYRnpeqoi7GqAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_fcd2136e-3a2b-4104-9cbc-7cdd4ea29ff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Main Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-3bd6-704c-9189-fb97bd8bca33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-3bd6-704c-9189-fb97bd8bca33",
        "storage_key": "property/6767906449167661/019ffd1c-3bd6-704c-9189-fb97bd8bca33.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ci.boerne.tx.us/173/Main-Plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=3765771273945803448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-plaza",
      "poi_latitude": "29.7938156",
      "poi_longitude": "-98.7331755",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTMmAPJ3XIYRuOrokAW1QjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ba743f6e-4aae-45c0-87de-14689f28f157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Patrick Heath Public Library",
      "poi_type": "Education",
      "poi_address": "451 N Main St, Boerne, TX 78006, USA",
      "poi_short_description": "Small-town public library offering a large selection of books, digital resources, and programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-37f3-769a-a0f9-cb507911c916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-37f3-769a-a0f9-cb507911c916",
        "storage_key": "property/6767906449167661/01a025fc-37f3-769a-a0f9-cb507911c916.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boernelibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15323600325521543494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patrick-heath-public-library",
      "poi_latitude": "29.7981611",
      "poi_longitude": "-98.7312187",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-249-3053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cbd-727e-8789-374a7e0a9a35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cbd-727e-8789-374a7e0a9a35",
        "storage_key": "property/6767906449167661/01a025fc-4cbd-727e-8789-374a7e0a9a35.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJh949f7l2XIYRRpHF4k5dqNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5d61c807-b01a-47f7-a7b5-71b863803a16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Herff Farm",
      "poi_type": "Entertainment",
      "poi_address": "33 Herff Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-6dd0-7543-9db8-cef38622dde6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-6dd0-7543-9db8-cef38622dde6",
        "storage_key": "property/6767906449167661/019ffd1c-6dd0-7543-9db8-cef38622dde6.webp",
        "width": 666,
        "height": 1280
      },
      "poi_business_url": "https://cibolo.org/locations/herff-farm/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14922666796886428395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herff-farm",
      "poi_latitude": "29.7809531",
      "poi_longitude": "-98.7142445",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-249-4616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYLmXc12XIYR64ruWWP2F88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_792872a2-35e6-4ec9-9114-14bba3947376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "106 City Park Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Swimming, kayaking & picnics are main activities at this lawn & beach beside a manmade reservoir.",
      "poi_long_description": "Swimming, kayaking & picnics are main activities at this lawn & beach beside a manmade reservoir.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-3b74-75b4-b395-1c4fccee6f3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-3b74-75b4-b395-1c4fccee6f3a",
        "storage_key": "property/6767906449167661/019ffd1c-3b74-75b4-b395-1c4fccee6f3a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.ci.boerne.tx.us/167/Boerne-City-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10729984996638166905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-city-park",
      "poi_latitude": "29.7862381",
      "poi_longitude": "-98.7125352",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-249-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXDMf7Z1XIYReY_jKYGQ6JQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2457e4ea-8666-4e77-8f9f-04971fc8fe3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Fair Oaks Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "27638 I-10, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-38b9-71aa-855d-50771cdf2ea7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-38b9-71aa-855d-50771cdf2ea7",
        "storage_key": "property/6767906449167661/01a025fc-38b9-71aa-855d-50771cdf2ea7.webp",
        "width": 1170,
        "height": 768
      },
      "poi_business_url": "https://fairoaksemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6856343807138537104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-oaks-emergency-room",
      "poi_latitude": "29.7088147",
      "poi_longitude": "-98.6570519",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-903-2424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT6vwwEF7XIYRkB5xul2gJl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_f225a71b-4910-4d56-8cbc-6c79466ac848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Methodist ER Boerne",
      "poi_type": "Health and Wellness",
      "poi_address": "134 Menger Springs, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-391d-7111-9848-2d51d4a99177.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-391d-7111-9848-2d51d4a99177",
        "storage_key": "property/6767906449167661/01a025fc-391d-7111-9848-2d51d4a99177.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-er-boerne?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3872165321147559702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-er-boerne",
      "poi_latitude": "29.7717292",
      "poi_longitude": "-98.7305658",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-331-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwsOmklxXIYRFi-WDtixvDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_83656836-f496-4473-9ca7-b114f5d43251",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "My Urgent Care Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "910 River Rd #101, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1b-6adf-7177-8989-d2d0fc16410e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1b-6adf-7177-8989-d2d0fc16410e",
        "storage_key": "property/6767906449167661/019ffd1b-6adf-7177-8989-d2d0fc16410e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myurgentcareclinic-boerne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6572736904445624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-urgent-care-clinic",
      "poi_latitude": "29.7893474",
      "poi_longitude": "-98.7194064",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-331-2391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ffiBwl3XIYRuD5kkN5ZFwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_17f5c4b5-b829-4560-a1ab-08ed991b0a2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9089 Fair Oaks Pkwy, Fair Oaks Ranch, TX 78015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-39e2-73b9-a644-57c84d7540b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-39e2-73b9-a644-57c84d7540b8",
        "storage_key": "property/6767906449167661/01a025fc-39e2-73b9-a644-57c84d7540b8.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fair-oaks-ranch-tx-pharmacies/9089-fair-oaks-parkway-fair-oaks-ranch-tx-78015/storeid=10540?WT.mc_id=LS_GOOGLE_RX_10540",
      "poi_directions_map_url": "https://maps.google.com/?cid=13315386416719945738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7204557",
      "poi_longitude": "-98.6652429",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-698-9538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9e-720e-bbbf-4de1883e421e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9e-720e-bbbf-4de1883e421e",
        "storage_key": "property/6767906449167661/01a025fc-4c9e-720e-bbbf-4de1883e421e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22M8ynZwXIYRCmCn52XBybg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f97002eb-1ce8-4c5b-b208-a228b4277b74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "420 W Bandera Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1b-6d2c-73f8-b3fe-342962962b62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1b-6d2c-73f8-b3fe-342962962b62",
        "storage_key": "property/6767906449167661/019ffd1b-6d2c-73f8-b3fe-342962962b62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=3454218225067322840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.781808",
      "poi_longitude": "-98.733765",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 37 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 830-816-2093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4c9e-720e-bbbf-4de1883e421e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4c9e-720e-bbbf-4de1883e421e",
        "storage_key": "property/6767906449167661/01a025fc-4c9e-720e-bbbf-4de1883e421e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdkQWbJ2XIYR2G3RqSzZ7y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d5b4aeab-ed29-4306-b775-a8c7d44f4aae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Core Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1580 River Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-3f01-7148-b8a2-34cd5caeb10e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-3f01-7148-b8a2-34cd5caeb10e",
        "storage_key": "property/6767906449167661/01a025fc-3f01-7148-b8a2-34cd5caeb10e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.coreathleticclubboerne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17457159267295021274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "core-athletic-club",
      "poi_latitude": "29.7888814",
      "poi_longitude": "-98.703976",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-444-0707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8XeZMN3XIYR2siJktxJRPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3ef79096-676e-4f6b-ba16-09c98dab1ea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "820 Adler Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-9291-7014-982a-f02da0326b9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-9291-7014-982a-f02da0326b9e",
        "storage_key": "property/6767906449167661/019ffd1c-9291-7014-982a-f02da0326b9e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ymcasatx.org/boerne",
      "poi_directions_map_url": "https://maps.google.com/?cid=10258931896457215514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-family-ymca",
      "poi_latitude": "29.8054625",
      "poi_longitude": "-98.7240303",
      "poi_miles_from_property": "13.8",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 830-815-1040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa6u4QrV2XIYRGr5BpzQMX44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_8ee15b5b-1e9a-46c8-aa22-a65c71ad023c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "HOTWORX - Boerne TX - Napa Oaks",
      "poi_type": "Health and Wellness",
      "poi_address": "27650 I-10 Suite 108, Boerne, TX 78015, USA",
      "poi_short_description": "Fitness studio offering a variety of virtually instructed infrared sauna workouts, plus free weights.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1b-d5e8-753d-ba5d-df4f56821985.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1b-d5e8-753d-ba5d-df4f56821985",
        "storage_key": "property/6767906449167661/019ffd1b-d5e8-753d-ba5d-df4f56821985.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/boerne-napaoaks?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2836463604798787922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---boerne-tx---napa-oaks",
      "poi_latitude": "29.7094287",
      "poi_longitude": "-98.6580577",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 830-388-7993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEelGnOh3XIYRUhFbzp4kXSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_8b232179-16e2-4b86-9e2b-18b045137c2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "CrossFit Fair Oaks Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "28451 I-10 #103, Boerne, TX 78006, USA",
      "poi_short_description": "Gym, also a CrossFit training destination offering classes for athletes of all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-3c5b-72bd-906f-89105dd0222c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-3c5b-72bd-906f-89105dd0222c",
        "storage_key": "property/6767906449167661/01a025fc-3c5b-72bd-906f-89105dd0222c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crossfitfairoaksranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=539502375365108695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-fair-oaks-ranch",
      "poi_latitude": "29.7199663",
      "poi_longitude": "-98.6684575",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 830-368-4198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ctXnnFwXIYR1-MdT42yfAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d58e05e3-3a46-409e-97eb-1f01c7c2c34c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "River Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "River Road Park, 100 River Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Park featuring a river walk alongside abundant ducks and turtles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-640d-7049-93d2-22cfc87771b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-640d-7049-93d2-22cfc87771b5",
        "storage_key": "property/6767906449167661/019ffd1c-640d-7049-93d2-22cfc87771b5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.ci.boerne.tx.us/181/River-Road-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11290867328507359975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-road-park",
      "poi_latitude": "29.7894278",
      "poi_longitude": "-98.7264119",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu6nM9bd2XIYR57K-gQM4sZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c6df7dc4-ea51-4b88-898d-64aa017b9d36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne City Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "21 Upper Cibolo Creek Rd, Boerne, TX 78006, USA",
      "poi_short_description": "Park on Boerne Lake with a fishing pier, boat dock, BBQs & picnic tables, plus a butterfly garden.",
      "poi_long_description": "Park on Boerne Lake with a fishing pier, boat dock, BBQs & picnic tables, plus a butterfly garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4422-720a-9bfe-3caf13475f1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-4422-720a-9bfe-3caf13475f1b",
        "storage_key": "property/6767906449167661/01a025fc-4422-720a-9bfe-3caf13475f1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ci.boerne.tx.us/169/City-Lake-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15083652052360228608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-city-lake-park",
      "poi_latitude": "29.8301574",
      "poi_longitude": "-98.7755033",
      "poi_miles_from_property": "17.1",
      "poi_walking_minutes": "6 hours 21 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 830-249-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSV-DrZ1XIYRAO-FAKDlU9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6bbc01b7-0047-4729-a051-2ab209e7d446",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Northside Neighborhood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Currey, Creek Trail, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ci.boerne.tx.us/1341/Northside-Neighborhood-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18115572099800994190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-neighborhood-park",
      "poi_latitude": "29.8031684",
      "poi_longitude": "-98.7173485",
      "poi_miles_from_property": "13.7",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyuZcSt3XIYRjpGdJ9hwZ_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_39e6978a-444b-4dce-976f-688d236c09f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Kinderpark",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Boerne, TX 78006, USA",
      "poi_short_description": "Neighborhood park featuring a fenced/gated playground with a long slide and a climbing wall, plus a gazebo.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-43ba-76f3-82a4-cc121bca1f2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-43ba-76f3-82a4-cc121bca1f2e",
        "storage_key": "property/6767906449167661/01a025fc-43ba-76f3-82a4-cc121bca1f2e.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "http://www.ci.boerne.tx.us/180/Kinderpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=7309259335588498764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kinderpark",
      "poi_latitude": "29.7840144",
      "poi_longitude": "-98.7308563",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-248-1635",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2f8d-7384-844c-bfcadcee440f",
        "storage_key": "property/6767906449167661/019ffd19-2f8d-7384-844c-bfcadcee440f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjf2SpbZ2XIYRTM31vKO0b2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8ecde123-4726-403e-add9-3e8df00247fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne ISD Administration Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "235 Johns Rd, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-a361-73bc-8ee8-f255b1bbfaa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-a361-73bc-8ee8-f255b1bbfaa3",
        "storage_key": "property/6767906449167661/019ffd1c-a361-73bc-8ee8-f255b1bbfaa3.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "http://www.boerneisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16107029376414231808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-isd-administration-center",
      "poi_latitude": "29.7951531",
      "poi_longitude": "-98.736104",
      "poi_miles_from_property": "13.5",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-357-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb9-778c-ac31-7ca7046e71e8",
        "storage_key": "property/6767906449167661/019ffd19-2fb9-778c-ac31-7ca7046e71e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRQg-yLx2XIYRAK3zD-Gph98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab2d0ac5-2416-49f2-bf04-6d59890b8ced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Kendall County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 E San Antonio Ave #127, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-a1b7-705d-8e07-bb1c3c0f130a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-a1b7-705d-8e07-bb1c3c0f130a",
        "storage_key": "property/6767906449167661/019ffd1c-a1b7-705d-8e07-bb1c3c0f130a.webp",
        "width": 1280,
        "height": 770
      },
      "poi_business_url": "http://www.co.kendall.tx.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16713880065164251264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kendall-county-courthouse",
      "poi_latitude": "29.7940349",
      "poi_longitude": "-98.7305679",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-249-9343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cc7-7299-825c-3549e03209e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cc7-7299-825c-3549e03209e9",
        "storage_key": "property/6767906449167661/01a025fc-4cc7-7299-825c-3549e03209e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJabJwULl2XIYRgBCZhl2h8-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_f9a088ad-339d-486f-8e62-86f1207f2097",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Boerne City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "447 N Main St, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-a6ce-753c-a288-773e618fe1ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-a6ce-753c-a288-773e618fe1ce",
        "storage_key": "property/6767906449167661/019ffd1c-a6ce-753c-a288-773e618fe1ce.webp",
        "width": 1280,
        "height": 1161
      },
      "poi_business_url": "http://www.ci.boerne.tx.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615069361117933601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boerne-city-hall",
      "poi_latitude": "29.7974552",
      "poi_longitude": "-98.7330617",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 830-249-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cc7-7299-825c-3549e03209e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cc7-7299-825c-3549e03209e9",
        "storage_key": "property/6767906449167661/01a025fc-4cc7-7299-825c-3549e03209e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4F7zr52XIYRITA52yEFDEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f5f88500-cdd3-4c48-8f5a-78b381853132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "29388 I-10, Boerne, TX 78006, USA",
      "poi_short_description": "Popular grocery store chain with a bakery and a pharmacy, plus meat and produce sections.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1a-e6fc-74cc-9d0a-5c4fddd3feb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-e6fc-74cc-9d0a-5c4fddd3feb2",
        "storage_key": "property/6767906449167661/019ffd1a-e6fc-74cc-9d0a-5c4fddd3feb2.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/boerne/fair-oaks-h-e-b-793?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores&utm_content=fair-oaks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3453653247022816274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.7338144",
      "poi_longitude": "-98.6797737",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 830-368-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-3016-7471-b4bb-91a06562ef3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-3016-7471-b4bb-91a06562ef3b",
        "storage_key": "property/6767906449167661/019ffd19-3016-7471-b4bb-91a06562ef3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7zrpp1FxXIYRElwrdlTX7S8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cd6fc478-5756-413e-8c07-7b385b041bff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Vic Vaughan Toyota of Boerne",
      "poi_type": "Shopping & Retail",
      "poi_address": "31205 Frontage Rd #10, Boerne, TX 78006, USA",
      "poi_short_description": "Car dealer stocking new vehicles plus pre-owned and certified models, along with a parts department.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-a8c7-762d-8ee3-1d1665e45745.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-a8c7-762d-8ee3-1d1665e45745",
        "storage_key": "property/6767906449167661/019ffd1c-a8c7-762d-8ee3-1d1665e45745.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.toyotaofboerne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2541472575896383385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vic-vaughan-toyota-of-boerne",
      "poi_latitude": "29.7507746",
      "poi_longitude": "-98.7024189",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 833-808-3925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fbb-73bd-8a1d-7754d773781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fbb-73bd-8a1d-7754d773781f",
        "storage_key": "property/6767906449167661/019ffd19-2fbb-73bd-8a1d-7754d773781f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ10_rJOJwXIYRmW-zrNcfRSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_dealer"
    },
    {
      "id": "custom_09410e21-509e-46ab-b55c-3ff1b7def798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Albany Engineered Composites",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1281 N Main St, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.albint.com/engineered-composites/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14385025522588899472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albany-engineered-composites",
      "poi_latitude": "29.8127479",
      "poi_longitude": "-98.7448806",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-249-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ445zjIJ2XIYRkNjWZn_gocc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_bc85f719-93b0-4621-b1d1-1dfd56f8b312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Mission Pharmacal",
      "poi_type": "Major Employers & Offices",
      "poi_address": "38505 I-10, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd1c-a867-74d1-840e-7e4e325512e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-a867-74d1-840e-7e4e325512e3",
        "storage_key": "property/6767906449167661/019ffd1c-a867-74d1-840e-7e4e325512e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://missionpharmacal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14905125152359532373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-pharmacal",
      "poi_latitude": "29.81058549999999",
      "poi_longitude": "-98.7544764",
      "poi_miles_from_property": "15.8",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-249-9822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoU61kiV0XIYRVUch91qk2c4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_530666bd-d6d4-4d88-b6c0-af6067479ba4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Cibolo Creek Health and Rehabilitation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1440 River Rd #1958, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-43ab-77bd-bbfc-848f0d978fa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-43ab-77bd-bbfc-848f0d978fa3",
        "storage_key": "property/6767906449167661/01a025fc-43ab-77bd-bbfc-848f0d978fa3.webp",
        "width": 1067,
        "height": 800
      },
      "poi_business_url": "https://cibolocreekhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7881905819464137149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cibolo-creek-health-and-rehabilitation-center",
      "poi_latitude": "29.79",
      "poi_longitude": "-98.7096744",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 830-816-5095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-2fb1-70c8-9dad-fce5727908c0",
        "storage_key": "property/6767906449167661/019ffd19-2fb1-70c8-9dad-fce5727908c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9aYK9B2XIYRvXk-KpUnYm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_8e012638-5662-43eb-bdba-41eb19004ac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "poi_name": "Kendall County Law Enforcement Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6 Staudt St, Boerne, TX 78006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4543-7447-b718-0081d517ace6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a025fc-4543-7447-b718-0081d517ace6",
        "storage_key": "property/6767906449167661/01a025fc-4543-7447-b718-0081d517ace6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.co.kendall.tx.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6506069273061200004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kendall-county-law-enforcement-center",
      "poi_latitude": "29.8062467",
      "poi_longitude": "-98.7229101",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/01a025fc-4cc7-7299-825c-3549e03209e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a025fc-4cc7-7299-825c-3549e03209e9",
        "storage_key": "property/6767906449167661/01a025fc-4cc7-7299-825c-3549e03209e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT95fkOt2XIYRhJDlgIgzSlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f91466932ce22ddcdf79f12c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a10f9ddc27085111ec2f8f0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ceea91647ed59e3223271855",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_042adfe0a2bd40e406df5aad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a899765e32e267e30c2ac4d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ab99dc634ed1b833493bf1e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6b5081b777f4af1d477037a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "rating": "5",
      "name": "Coach Poobah",
      "text": "I believe I was the first move in at The Emilia and have thoroughly enjoyed my time living here. What truly sets this community apart is the exceptional staff; professional, available, accommodating, welcoming, and transparent..\nThank you for making me feel at home!\nCoach",
      "date": "2026-07-13",
      "title": "false"
    },
    {
      "id": "ec_735b202f4560f5790b3e9c03",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "rating": "5",
      "name": "mahdi mahmoodabadi",
      "text": "I had a great experience with the leasing office, especially Beth and Martha. They were incredibly kind, professional, and very responsive throughout the entire process. They helped me a lot with completing the lease and made everything simple and stress-free.\n\nI really appreciate how patient and supportive they were, always ready to answer my questions and guide me step by step. Their positive attitude made a big difference.\n\nThe apartment itself is excellent—clean, well-maintained, and exactly what I was looking for. The whole community feels comfortable and welcoming.\n\nThank you, Beth and Martha, for your outstanding service and for making this experience so smooth. I highly recommend this place to anyone looking for a new home!",
      "date": "2026-03-31",
      "title": "false"
    },
    {
      "id": "ec_bcd2a0ec93be388e47570790",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "rating": "5",
      "name": "Jacob D",
      "text": "My wife and I were looking for a possible apartment to live in. Unfortunately we choose to stay at where we are now. But I just want to say this property is very elegant, the staff are kind, patient, and professional. I want to thank them for giving us the time to look at the possibilities and we are still amazed by it. If you want a small community that’s in the hill country, this is the right place.",
      "date": "2026-07-02",
      "title": "false"
    },
    {
      "id": "ec_b99f025b66e110c67da843a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "rating": "5",
      "name": "Tadley Pontremoli",
      "text": "Just moved here and Beth was absolutely amazing! She helped us through all of our crazy questions and was very quick with everything! Loving it so far!",
      "date": "2026-05-10",
      "title": "false"
    },
    {
      "id": "ec_d7d0417c4e9d2c5106979dac",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "rating": "5",
      "name": "Mari",
      "text": "Beth and Martha have been so wonderful with the entire process, from the tours to moving in they have helped me so much every step of the way! Mr.Rick, our groundskeeper, is such a pleasant gentleman too! One week into living here and I am very happy here, no complaints🥰 thank you Beth, Martha, and Rick!",
      "date": "2026-04-17",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_22fbc9e4-1a1f-421e-aa1b-a0f611c22aa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167661/019ffd18-e45d-70f8-a1d1-3ea38ea13a8f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Exterior view of the apartment building and parking lot.",
        "public_id": "019ffd18-e45d-70f8-a1d1-3ea38ea13a8f",
        "storage_key": "property/6767906449167661/019ffd18-e45d-70f8-a1d1-3ea38ea13a8f.webp",
        "width": 2000,
        "height": 1000
      },
      "virtual_tour_title": "Emilia Apartments",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6976d2a73d909166ac064c28&sourceId=1001"
    }
  ],
  "faqs": [
    {
      "id": "custom_1a614f57-a1c3-4b3d-984d-3784f9afaaa9",
      "question": "What is the best neighborhood to rent an apartment in Northwest San Antonio?",
      "answer": "Northwest San Antonio offers a variety of desirable neighborhoods, but one of the best places to rent an apartment is the growing IH-10/Ralph Fair Road corridor. This area provides the perfect blend of Hill Country charm, modern conveniences, and easy access to San Antonio.\n\nEmilia is ideally located near IH-10, making it easy to commute to San Antonio with nearby access to Boerne's small-town atmosphere. Residents are just minutes from The Shops at La Cantera, The Rim, Hill Country Mile, local dining, grocery stores, and outdoor recreation. The community is also conveniently located near Northside ISD schools and several major employers.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_f43608d7-ce45-4e2e-ac40-37efc5192f2d",
      "question": "What makes living in Northwest San Antonio and Boerne, TX unique?",
      "answer": "Convenient Location\nEmilia sits just off IH-10 in the Leon Springs corridor, about 5 miles from Camp Bullis and 8 from La Cantera, The Rim, and UTSA. If you work\nalong IH-10 or Loop 1604, you drive in against traffic instead of with it. \n\nHill Country Lifestyle\nBeautiful landscapes, local wineries, hiking trails, and a welcoming small-town atmosphere. The sunsets aren't too bad either.\n\nShopping & Dining\nThe Leon Springs H-E-B and the restaurants along the access road handle the everyday. National retailers, dining, and entertainment at\nThe Shops at La Cantera and The Rim are about 8 miles south. For a slower afternoon, the boutiques along the Hill Country Mile in downtown Boerne are roughly 11 miles northwest.\n\nOutdoor Recreation\nFriedrich Wilderness Park and Eisenhower Park are both a few minutes away, with miles of trails through the same Hill Country terrain that surrounds the community. Cascade Caverns and Boerne City Lake Park are an easy weekend drive.\n\nSchools & Employers\nEmilia is zoned to Northside ISD, including Leon Springs Elementary about 2 miles up IH-10. Major employers within a short commute include Camp Bullis, USAA, Valero, the South Texas Medical Center, and the growing medical and technology corridor along IH-10 and Loop 1604.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_86887e40-8868-45dd-a80d-13a9971eef61",
      "question": "What is there to do near Emilia at Fair Oaks? ",
      "answer": "Plenty, and most of it is within a fifteen minute drive.\n\nRight up the access road\nThe Leon Springs corridor has a real restaurant scene for a stretch of IH-10, from barbecue and Tex-Mex to the Leon Springs H-E-B for everything else. Rudy's, the original location (this is major), is a few minutes north.\n\nShopping and entertainment\nThe Shops at La Cantera and The Rim are about 8 miles south, with national retailers, dining, a movie theater, and the TopGolf and Main Event cluster nearby. Six Flags Fiesta Texas is at the same exit.\n\nOutdoors\nFriedrich Wilderness Park and Eisenhower Park are both minutes away, with several miles of trails through Hill Country terrain and real\nelevation change. Government Canyon State Natural Area is a little further west for a longer hike.\n\nGolf\nThe Dominion, Cordillera Ranch, and the TPC San Antonio courses at La Cantera are all within a short drive.\n\nWeekends in Boerne\nDowntown Boerne is about 11 miles northwest, where the Hill Country Mile has boutique shopping, local restaurants, and Boerne Market Days\non the second weekend of the month. The Cibolo Center for Conservation and Boerne City Lake Park are both close to downtown. Worth the trip, though not a daily one.\n\nWineries and the wider Hill Country\nThe wineries and breweries along the 46 and 290 corridors open up from here, and Fredericksburg is an easy day trip.\n\nIn other words, pretty much the best San Antonio has to offer. You'll love it. ",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_bb3bfd75-e812-4d15-8f86-6a631d03d0c4",
      "question": "How close is Emilia at Fair Oaks to major employers in San Antonio? ",
      "answer": "Emilia sits just off IH-10 inside the Leon Springs corridor, which puts most of northwest San Antonio's employment centers within a\ntwenty minute drive. Because the community is outside Loop 1604, most of that commute runs against the inbound traffic. Win! \n\nMilitary and government\nCamp Bullis is approximately 5 miles, making Emilia one of the closest apartment communities to the installation. Bexar County offices and\nthe San Antonio Police Department's northwest substation are within a short drive, and the wider Joint Base San Antonio network is accessible from IH-10 and Loop 1604.\n\nHealthcare\nThe South Texas Medical Center is approximately 15 miles and UT Health San Antonio is approximately 16, both a straight run down IH-10.\nMethodist Hospital Texsan sits on the same corridor at approximately 15 miles. Methodist Stone Oak and the medical offices along Loop 1604\nare approximately 18 miles east. Closer to home, Camp Bullis hosts the Army's Medical Readiness Training Center about 5 miles up IH-10, and\nMethodist ER Boerne and UT Health Hill Country are both within a short drive for everyday care.\n\nCorporate\nValero's corporate campus is approximately 9 miles and USAA is approximately 13. The office corridor along IH-10 and Loop 1604 near\nLa Cantera is approximately 8 miles.\n\nEducation\nUTSA's main campus is approximately 8 miles. Northside ISD administration and the district's northwest campuses are within a short drive, and Leon Springs Elementary is about 2 miles up IH-10. Remember that Emilia at Fair Oaks is zoned to Northside ISD. \n\nRetail and hospitality\nThe Shops at La Cantera, The Rim, and Six Flags Fiesta Texas are all clustered at approximately 8 miles. The Leon Springs H-E-B is minutes\ndown the access road.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_e2d9f47a-f26a-4834-80f7-725c7a14184c",
      "question": "What amenities does Emilia offer?",
      "answer": "Resort-Style Swimming Pool\nRelax and unwind at Emilia's beautiful resort-style swimming pool.\n\nModern Fitness Center\nStay active with a fully equipped fitness center featuring modern exercise equipment.\n\nResident Clubhouse\nGather with friends, work remotely, or relax in the stylish resident clubhouse.\n\nEV Charging Stations\nConvenient electric vehicle charging stations support eco-friendly living.\n\nSpacious Apartment Homes\nChoose from thoughtfully designed studio, one-, and two-bedroom floor plans featuring contemporary finishes, washer and dryer connections, and modern conveniences.\n\nPrime Boerne Location\nLocated near IH-10 with convenient access to shopping, dining, entertainment, outdoor recreation, and major employers.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_9727d056-9b6e-4700-bc11-cc36c72a6477",
      "question": "What school district serves Emilia at Fair Oaks?",
      "answer": "Emilia at Fair Oaks is zoned to Northside Independent School District (NISD), not Boerne ISD. This is a common point of confusion given the Boerne mailing address.\n\n\nWhich schools are residents zoned to?\n\nElementary: Leon Springs Elementary, 23881 IH 10 W, San Antonio,\n(210) 397-4400\n\nMiddle: Rawlinson Middle School, 14100 Vance Jackson, San Antonio,\n(210) 397-4900\n\nHigh School: Clark High School, 5150 De Zavala Rd, San Antonio,\n(210) 397-5150\n\n\nHow far are the schools from the community?\n\nLeon Springs Elementary is approximately 2 miles from Emilia, just up the IH-10 access road. Rawlinson Middle School and Clark High School\nare further toward Loop 1604, at roughly 11 miles each. Northside ISD provides bus service to all three campuses.\n\n\nHow do I find out about bus routes and pickup times?\n\nNorthside ISD operates a bus route lookup by address. Residents can enter 7868 Lost Creek Gap to retrieve their assigned route: https://boundariesandbuses.nisd.net/\n\n\nWho do I contact about school zoning questions?\nSchool attendance boundaries are set by Northside ISD and are subject to change. Please direct boundary questions to the district at\n(210) 397-8796. We recommend confirming current zoning directly with NISD before making a housing decision based on school assignment.",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_7cd23dad-6eb5-47cb-b743-7713d8e8d720",
      "question": "Does Emilia at Fair Oaks offer a preferred employer discount? ",
      "answer": "Yes. Emilia offers a preferred employer discount to people working in several of the fields and organizations that anchor this corridor:\n\nActive-duty military\nBoerne and San Antonio Fire Departments\nSan Antonio Police Department\nBoerne ISD and Northside ISD\nBexar County\nHealthcare professionals\nUTSA\nValero Corporate\nH-E-B\nWalmart\nSix Flags\n\nGo ahead and reach out to us to see what offers are available today.",
      "category": "",
      "source": "custom"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a04a29-4a14-770a-b3cc-4b132f55a649",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Emilia Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661"
    },
    {
      "lead_collector_id": "01a04a29-4a92-738b-bff5-e5fbc265381b",
      "lead_source": "LANDING_PAGE",
      "name": "Emilia Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "apartments-with-pool-boerne-tx-emilia",
      "search_query": "apartments with pool boerne tx",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Boerne, TX",
      "h2_subtitle": "Discover Emilia, the perfect choice for those seeking apartments with a pool in Boerne, TX. Enjoy modern conveniences and exceptional amenities.",
      "page_copy": "Welcome to Emilia, where luxury meets comfort in Boerne, TX. If you're searching for apartments with a pool, you'll love our beautiful swimming pool, perfect for relaxing weekends or post-work swims. Nestled in the serene landscape of Lost Creek, Emilia offers residents a harmonious blend of convenience and tranquility.\n\nOur community goes beyond just having a pool. At Emilia, you will enjoy access to a state-of-the-art fitness center and a welcoming clubhouse, fostering an environment that supports both active and social lifestyles. With in-unit washer and dryer connections and inclusive cable and internet, Emilia ensures that residents experience modern living at its finest in the heart of Boerne, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Boerne, TX - Emilia",
      "seo_description": "Explore Emilia in Boerne, TX: Apartments with a pool, fitness center, and modern amenities for a perfect blend of comfort and luxury.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-bexar-county-emilia",
      "search_query": "fitness center apartments in bexar county",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Bexar County",
      "h2_subtitle": "Discover Emilia in Bexar County, featuring a modern fitness center. Ideal for an active lifestyle with exclusive amenities.",
      "page_copy": "Located in Bexar County, Emilia offers apartments for those seeking a fitness-focused lifestyle. Our fully equipped fitness center provides space for a variety of workout routines in an inviting setting.\nEmilia also features a welcoming clubhouse, swimming pool, and in-unit washer and dryer connections. Cable and internet access support convenient, connected living. Experience modern apartment living at Emilia in Bexar County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Bexar County",
      "seo_description": "Discover Emilia's apartments in Bexar County, featuring a modern fitness center, swimming pool, and more amenities for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "clubhouse-apartments-boerne-78015-emilia",
      "search_query": "clubhouse apartments in boerne 78015",
      "category": "Amenity",
      "h1_title": "Apartments with a clubhouse in Boerne, 78015",
      "h2_subtitle": "Emilia offers premier apartments with a clubhouse in Boerne, TX 78015. Ideal for social gatherings and relaxation.",
      "page_copy": "Emilia Apartments, located in the scenic surroundings of Boerne, 78015, features a luxurious clubhouse that stands as the heart of our vibrant community. Perfect for hosting social events or unwinding after a busy day, the clubhouse provides residents with a spacious and stylish environment to enjoy at their leisure. Whether it's gathering with friends or meeting neighbors, Emilia is where connections flourish.\n\nIn addition to the incredible clubhouse, Emilia offers a range of top-tier amenities. Residents enjoy a refreshing swimming pool, a fully equipped fitness center, and in-unit washer and dryer connections. Each apartment is outfitted with cable and internet, ensuring convenient and modern living. Discover the social and elegant lifestyle waiting for you at Emilia in Boerne, 78015.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a clubhouse in Boerne, 78015",
      "seo_description": "Explore Emilia's clubhouse apartments in Boerne, 78015. Enjoy community spaces, a swimming pool, and modern amenities for an elevated lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "apartments-with-ev-charging-stations-boerne-emilia",
      "search_query": "apartments with ev charging stations boerne",
      "category": "Amenity",
      "h1_title": "Apartments with EV Charging in Boerne",
      "h2_subtitle": "Emilia offers apartments with EV charging stations in Boerne, TX, providing added convenience for electric vehicle drivers.",
      "page_copy": "Emilia in Boerne offers electric vehicle charging stations, providing added convenience for residents with electric vehicles. Our community combines modern apartment features with thoughtful amenities designed to support everyday living. Located at 7868 Lost Creek Gap, Emilia provides a comfortable living experience in Boerne, TX.\nResidents can enjoy a beautifully designed swimming pool, a fully equipped fitness center, and an inviting clubhouse. Each apartment features in-unit washer and dryer connections, along with cable and internet for convenient, connected living. Discover the blend of comfort, convenience, and modern amenities waiting for you at Emilia.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with EV Charging in Boerne",
      "seo_description": "Emilia in Boerne offers modern apartment living with EV charging stations and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "in-unit-washer-dryer-connections-boerne-tx-emilia",
      "search_query": "in-unit washer and dryer connections apartments boerne tx",
      "category": "Amenity",
      "h1_title": "In-Unit Washer & Dryer Apartments in Boerne, TX",
      "h2_subtitle": "Experience the convenience of in-unit washer and dryer connections at Emilia Apartments in Boerne, TX.",
      "page_copy": "Located in Boerne, TX, Emilia offers modern living with in-unit washer and dryer connections in every home. This convenient feature allows residents to set up laundry appliances inside their apartments and simplify their daily routines.\n\nBeyond this amenity, Emilia features a fully equipped fitness center, a refreshing swimming pool, and an inviting clubhouse. Each apartment also features cable and internet access for connected living. Embrace modern comfort and convenience at Emilia in Boerne, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer & Dryer in Boerne",
      "seo_description": "Discover Emilia Apartments in Boerne, TX with in-unit washer and dryer connections, offering ultimate convenience and luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "studio-apartments-boerne-tx-emilia",
      "search_query": "studio apartments in Boerne TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Boerne, TX",
      "h2_subtitle": "Find the perfect studio apartment at Emilia in Boerne, TX. Ideal for modern, minimalist living.",
      "page_copy": "At Emilia in Boerne, TX, you’ll find studio apartments designed for a modern and sophisticated lifestyle. Perfect for those who appreciate efficient living with high-quality finishes, our studio apartments offer a blend of comfort and style. Each apartment is thoughtfully designed to maximize space while providing the essentials for daily living.\nEmilia also offers top-notch amenities. Residents have access to a refreshing swimming pool, a fully equipped fitness center, and a stylish clubhouse for socializing. With in-unit washer and dryer connections and cable and internet access, each studio is designed for convenience. Discover the charm of Boerne, TX, paired with the ease of studio living at Emilia.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Available in Boerne, TX",
      "seo_description": "Explore studio apartments at Emilia in Boerne, TX. Enjoy modern living with top-tier amenities and conveniences tailored for an effortless lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-bexar-county-emilia",
      "search_query": "one bedroom apartments Bexar County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Bexar County",
      "h2_subtitle": "Explore comfortable one-bedroom apartments at Emilia in Bexar County.",
      "page_copy": "Emilia offers stunning one-bedroom apartments in Bexar County, expertly designed for both comfort and style. Nestled in the scenic town of Boerne, these apartments provide the perfect sanctuary to call home. Each one-bedroom apartment features modern interiors that maximize space and functionality, ensuring you have room for relaxation and daily activities.\nBeyond the inviting interiors, Emilia enhances your living experience with community amenities. From enjoying leisurely days by the swimming pool to energizing workouts at the fitness center, everything is designed to complement your lifestyle. Our one-bedroom apartments also include in-unit washer and dryer connections, as well as cable and internet, to keep you connected. Come experience apartment living in Bexar County at Emilia.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Bexar County",
      "seo_description": "Discover spacious one-bedroom apartments at Emilia in Bexar County. Enjoy modern amenities and comfort in Boerne, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-78015-emilia",
      "search_query": "two bedroom apartments near 78015",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 78015",
      "h2_subtitle": "Discover spacious two bedroom apartments at Emilia, conveniently located near 78015 in Boerne, TX.",
      "page_copy": "Located in Boerne, Emilia offers exceptional two-bedroom apartments in the 78015 ZIP code. These apartments combine generous space with modern features. Each home is thoughtfully designed to balance functionality and style while accommodating a variety of living arrangements.\nBeyond the spacious interiors, Emilia offers a swimming pool, fully equipped fitness center, and welcoming clubhouse. In-unit washer and dryer connections, along with cable and internet access, support comfortable and connected living. Experience modern apartment living at Emilia in Boerne, TX 78015.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 78015, Boerne, TX",
      "seo_description": "Explore two bedroom apartments at Emilia near 78015 in Boerne, TX. Enjoy spacious layouts and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "apartments-near-ut-health-hill-country-boerne-emilia",
      "search_query": "apartments near UT Health Hill Country Boerne",
      "category": "Hospital",
      "h1_title": "Apartments Near UT Health Hill Country",
      "h2_subtitle": "Discover convenient living at Emilia with apartments located near UT Health Hill Country in Boerne, TX.",
      "page_copy": "Emilia offers apartments near UT Health Hill Country in Boerne, TX. Our community combines comfort and convenience with thoughtfully designed floor plans and modern amenities.\nResidents can enjoy a fully equipped fitness center, swimming pool, and welcoming clubhouse for relaxing or socializing. Each apartment features in-unit washer and dryer connections, along with cable and internet access. Experience modern apartment living with convenient access to UT Health Hill Country at Emilia.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UT Health Hill Country, Boerne",
      "seo_description": "Find modern apartments at Emilia near UT Health Hill Country in Boerne, TX. Enjoy a range of amenities with convenient access to nearby health services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "apartments-near-eisenhower-park-boerne-tx-emilia",
      "search_query": "apartments near eisenhower park boerne tx",
      "category": "Park",
      "h1_title": "Apartments Near Eisenhower Park, Boerne TX",
      "h2_subtitle": "Experience serene living at Emilia, with apartments conveniently located near Eisenhower Park in Boerne, TX.",
      "page_copy": "Situated near the natural beauty of Eisenhower Park, Emilia offers comfortable apartments in Boerne, TX. Ideal for nature enthusiasts and outdoor activity lovers, these apartments combine convenience with modern living.\nEmilia features a swimming pool, a fully equipped fitness center, and a welcoming clubhouse. Residents can enjoy a workout before exploring the trails at Eisenhower Park. Each apartment includes in-unit washer and dryer connections, plus cable and internet access. Discover modern apartment living with convenient access to Eisenhower Park at Emilia.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Eisenhower Park in Boerne, TX",
      "seo_description": "Discover comfortable apartments at Emilia near Eisenhower Park in Boerne, TX. Enjoy convenient access to nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167661",
      "source": "custom",
      "page_item_url": "apartments-close-to-raymond-russell-park-bexar-county-emilia",
      "search_query": "apartments close to raymond russell park bexar county",
      "category": "Park",
      "h1_title": "Apartments Close to Raymond Russell Park",
      "h2_subtitle": "Live near the beauty of Raymond Russell Park with Emilia's apartments situated conveniently in Bexar County.",
      "page_copy": "Discover the perfect blend of tranquility and modern living with Emilia’s apartments close to Raymond Russell Park in Bexar County. Ideal for those who enjoy outdoor adventures or peaceful retreats, our location offers convenient access to the park’s recreational spaces and scenic trails.\n\nEmilia provides premium amenities to complement an active lifestyle. Focus on wellness in our fully equipped fitness center or relax in the inviting clubhouse. Each apartment features in-unit washer and dryer connections, along with cable and internet access. Whether you’re seeking outdoor recreation or comfort at home, Emilia offers modern living near Raymond Russell Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Raymond Russell Park, Bexar County",
      "seo_description": "Emilia offers modern apartments near Raymond Russell Park in Bexar County. Enjoy nature's beauty and luxury living combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_gbp_utm",
      "type": "STRING",
      "value": "https://www.liveatemilia.com?utm_source=google"
    },
    {
      "ID": "custom_sem_utm",
      "type": "STRING",
      "value": "https://www.liveatemilia.com?utm_source=repli360ppc"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12795354604"
    },
    {
      "ID": "custom_website_utm",
      "type": "STRING",
      "value": "https://www.liveatemilia.com?utm_source=propertywebsite"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MQ9V34NK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57322531477"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/9zw4zm1gv87"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "0718b62e-7c6e-11f1-965b-1b5c846efee9"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bcd1707-74a8-4db5-b1de-bca46b2e676e"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-743-4715"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjNtckMzaVJ2WGRwVDd3VVFiOVF5NWc9PSIsInZhbHVlIjoicjJOT0xIbVpuRnlhSHlQQ1lhYkJjZz09IiwibWFjIjoiNTBjZGUzMTEzNzA4ODlhMTVmZGZkYjRlOGZhY2JmZTdhNTQ4M2QzYzk4ZTE5ZmJlNGQ2YzdkNTE4NjYyMDdlMSJ9"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_gbp_utm": "https://www.liveatemilia.com?utm_source=google",
  "custom_sem_utm": "https://www.liveatemilia.com?utm_source=repli360ppc",
  "custom_repli_id": "12795354604",
  "custom_website_utm": "https://www.liveatemilia.com?utm_source=propertywebsite",
  "custom_google_gtm_id": "GTM-MQ9V34NK",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57322531477",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/9zw4zm1gv87",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "0718b62e-7c6e-11f1-965b-1b5c846efee9",
  "custom_eliseai_organization_id": "4bcd1707-74a8-4db5-b1de-bca46b2e676e",
  "custom_ppc_tracking_phone_number": "844-743-4715",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjNtckMzaVJ2WGRwVDd3VVFiOVF5NWc9PSIsInZhbHVlIjoicjJOT0xIbVpuRnlhSHlQQ1lhYkJjZz09IiwibWFjIjoiNTBjZGUzMTEzNzA4ODlhMTVmZGZkYjRlOGZhY2JmZTdhNTQ4M2QzYzk4ZTE5ZmJlNGQ2YzdkNTE4NjYyMDdlMSJ9"
};

export const generatedAt = '2026-10-06T21:26:53.310Z';
